import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable, input, output, Component, ChangeDetectionStrategy, signal, model, computed, viewChild, effect, ViewEncapsulation, ViewContainerRef, Injector, ApplicationRef, ElementRef, Renderer2, forwardRef, Directive, NgModule, makeEnvironmentProviders } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import week from 'dayjs/plugin/weekOfYear';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { NgClass, CommonModule } from '@angular/common';
const _c0 = a0 => ({
  "active": a0
});
function RangesComponent_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 1);
    i0.ɵɵlistener("click", function RangesComponent_Conditional_0_For_3_Template_button_click_1_listener($event) {
      const range_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clickRange($event, range_r2));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const range_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.disableRange(range_r2))("ngClass", i0.ɵɵpureFunction1(3, _c0, range_r2 === ctx_r2.chosenRange()));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", range_r2, " ");
  }
}
function RangesComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "ul");
    i0.ɵɵrepeaterCreate(2, RangesComponent_Conditional_0_For_3_Template, 3, 5, "li", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.rangesArray());
  }
}
const _c1 = (a0, a1) => ({
  right: a0,
  left: a1
});
function CalendarComponent_Conditional_0_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 11);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_0_Conditional_1_Conditional_4_Template_th_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clickPrev($event, ctx_r1.sideEnum.left));
    });
    i0.ɵɵelementEnd();
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_7_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const m_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selected", ctx_r1.calendarVariables().left.dropdowns.currentMonth == m_r4)("value", m_r4)("disabled", ctx_r1.calendarVariables().left.dropdowns.inMinYear && m_r4 < ctx_r1.calendarVariables().left.minDate.month() || ctx_r1.calendarVariables().left.dropdowns.inMaxYear && m_r4 > ctx_r1.calendarVariables().left.maxDate.month());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale().monthNames[m_r4], " ");
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_7_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const y_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selected", y_r5 === ctx_r1.calendarVariables().left.dropdowns.currentYear);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", y_r5, " ");
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "select", 13);
    i0.ɵɵlistener("change", function CalendarComponent_Conditional_0_Conditional_1_Conditional_7_Template_select_change_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthChanged($event, ctx_r1.sideEnum.left));
    });
    i0.ɵɵrepeaterCreate(3, CalendarComponent_Conditional_0_Conditional_1_Conditional_7_For_4_Template, 2, 4, "option", 14, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 12);
    i0.ɵɵtext(6);
    i0.ɵɵelementStart(7, "select", 15);
    i0.ɵɵlistener("change", function CalendarComponent_Conditional_0_Conditional_1_Conditional_7_Template_select_change_7_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearChanged($event, ctx_r1.sideEnum.left));
    });
    i0.ɵɵrepeaterCreate(8, CalendarComponent_Conditional_0_Conditional_1_Conditional_7_For_9_Template, 2, 2, "option", 16, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale().monthNames[(tmp_3_0 = ctx_r1.calendarVariables().left.calendar) == null ? null : tmp_3_0[1][1].month()], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.calendarVariables().left.dropdowns.monthArrays);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_5_0 = ctx_r1.calendarVariables().left.calendar) == null ? null : tmp_5_0[1][1].format(" YYYY"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.calendarVariables().left.dropdowns.yearArrays);
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate2(" ", ctx_r1.locale().monthNames[(tmp_3_0 = ctx_r1.calendarVariables().left.calendar) == null ? null : tmp_3_0[1][1].month()], " ", (tmp_3_0 = ctx_r1.calendarVariables().left.calendar) == null ? null : tmp_3_0[1][1].format(" YYYY"), " ");
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_0_Conditional_1_Conditional_9_Template_th_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clickNext($event, ctx_r1.sideEnum.left));
    });
    i0.ɵɵelementEnd();
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 8)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.locale().weekLabel);
  }
}
function CalendarComponent_Conditional_0_Conditional_1_For_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dayofweek_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dayofweek_r7);
  }
}
function CalendarComponent_Conditional_0_Conditional_1_For_17_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 8)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_13_0;
    const row_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_13_0 = ctx_r1.calendarVariables().left.calendar) == null ? null : tmp_13_0[row_r8][0].week());
  }
}
function CalendarComponent_Conditional_0_Conditional_1_For_17_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 8)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_13_0;
    const row_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_13_0 = ctx_r1.calendarVariables().left.calendar) == null ? null : tmp_13_0[row_r8][0].isoWeek());
  }
}
function CalendarComponent_Conditional_0_Conditional_1_For_17_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 18);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_0_Conditional_1_For_17_For_4_Template_td_click_0_listener($event) {
      const col_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const row_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clickDate($event, ctx_r1.sideEnum.left, row_r8, col_r10));
    })("mouseenter", function CalendarComponent_Conditional_0_Conditional_1_For_17_For_4_Template_td_mouseenter_0_listener($event) {
      const col_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const row_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.hoverDate($event, ctx_r1.sideEnum.left, row_r8, col_r10));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_23_0;
    const col_r10 = ctx.$implicit;
    const row_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.calendarVariables().left.classes[row_r8][col_r10]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_23_0 = ctx_r1.calendarVariables().left.calendar) == null ? null : tmp_23_0[row_r8][col_r10].date());
  }
}
function CalendarComponent_Conditional_0_Conditional_1_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, CalendarComponent_Conditional_0_Conditional_1_For_17_Conditional_1_Template, 3, 1, "td", 8)(2, CalendarComponent_Conditional_0_Conditional_1_For_17_Conditional_2_Template, 3, 1, "td", 8);
    i0.ɵɵrepeaterCreate(3, CalendarComponent_Conditional_0_Conditional_1_For_17_For_4_Template, 3, 3, "td", 10, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.calendarVariables().left.classes[row_r8].classList);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showWeekNumbers() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showISOWeekNumbers() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.calendarVariables().left.calCols);
  }
}
function CalendarComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 2)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, CalendarComponent_Conditional_0_Conditional_1_Conditional_3_Template, 1, 0, "th")(4, CalendarComponent_Conditional_0_Conditional_1_Conditional_4_Template, 1, 0, "th", 4)(5, CalendarComponent_Conditional_0_Conditional_1_Conditional_5_Template, 1, 0, "th");
    i0.ɵɵelementStart(6, "th", 5);
    i0.ɵɵtemplate(7, CalendarComponent_Conditional_0_Conditional_1_Conditional_7_Template, 10, 2)(8, CalendarComponent_Conditional_0_Conditional_1_Conditional_8_Template, 1, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CalendarComponent_Conditional_0_Conditional_1_Conditional_9_Template, 1, 0, "th", 6)(10, CalendarComponent_Conditional_0_Conditional_1_Conditional_10_Template, 1, 0, "th");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tr", 7);
    i0.ɵɵtemplate(12, CalendarComponent_Conditional_0_Conditional_1_Conditional_12_Template, 3, 1, "th", 8);
    i0.ɵɵrepeaterCreate(13, CalendarComponent_Conditional_0_Conditional_1_For_14_Template, 3, 1, "th", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "tbody", 9);
    i0.ɵɵrepeaterCreate(16, CalendarComponent_Conditional_0_Conditional_1_For_17_Template, 5, 4, "tr", 10, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.showWeekNumbers() || ctx_r1.showISOWeekNumbers() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.calendarVariables().left.minDate || ctx_r1.calendarVariables().left.minDate.isBefore(ctx_r1.calendarVariables().left.calendar.firstDay) && (!ctx_r1.linkedCalendars() || true) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(!ctx_r1.calendarVariables().left.minDate || ctx_r1.calendarVariables().left.minDate.isBefore(ctx_r1.calendarVariables().left.calendar.firstDay) && (!ctx_r1.linkedCalendars() || true)) ? 5 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showDropdowns() && ctx_r1.calendarVariables().left.dropdowns ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.showDropdowns() || !ctx_r1.calendarVariables().left.dropdowns ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((!ctx_r1.calendarVariables().left.maxDate || ctx_r1.calendarVariables().left.maxDate.isAfter(ctx_r1.calendarVariables().left.calendar.lastDay)) && (!ctx_r1.linkedCalendars() || ctx_r1.singleDatePicker()) ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!((!ctx_r1.calendarVariables().left.maxDate || ctx_r1.calendarVariables().left.maxDate.isAfter(ctx_r1.calendarVariables().left.calendar.lastDay)) && (!ctx_r1.linkedCalendars() || ctx_r1.singleDatePicker())) ? 10 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showWeekNumbers() || ctx_r1.showISOWeekNumbers() ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.locale().daysOfWeek);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.calendarVariables().left.calRows);
  }
}
function CalendarComponent_Conditional_0_Conditional_2_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r12)("disabled", ctx_r1.timepickerVariables().left.disabledHours.indexOf(i_r12) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r12, " ");
  }
}
function CalendarComponent_Conditional_0_Conditional_2_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r13 = ctx.$implicit;
    const $index_r14 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r13)("disabled", ctx_r1.timepickerVariables().left.disabledMinutes.indexOf(i_r13) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.timepickerVariables().left.minutesLabel[$index_r14], " ");
  }
}
function CalendarComponent_Conditional_0_Conditional_2_Conditional_12_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r16 = ctx.$implicit;
    const $index_r17 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", i_r16)("disabled", ctx_r1.timepickerVariables().left.disabledSeconds.indexOf(i_r16) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.timepickerVariables().left.secondsLabel[$index_r17], " ");
  }
}
function CalendarComponent_Conditional_0_Conditional_2_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0, " : ");
    i0.ɵɵelementStart(1, "div", 19)(2, "select", 25);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_0_Conditional_2_Conditional_12_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.timepickerVariables().left.selectedSecond, $event) || (ctx_r1.timepickerVariables().left.selectedSecond = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_0_Conditional_2_Conditional_12_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.timeChanged($event, ctx_r1.sideEnum.left));
    });
    i0.ɵɵrepeaterCreate(3, CalendarComponent_Conditional_0_Conditional_2_Conditional_12_For_4_Template, 2, 3, "option", 21, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 23)(6, "span", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.startDate());
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.timepickerVariables().left.selectedSecond);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.timepickerVariables().left.seconds);
  }
}
function CalendarComponent_Conditional_0_Conditional_2_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "select", 26);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_0_Conditional_2_Conditional_13_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.timepickerVariables().left.ampmModel, $event) || (ctx_r1.timepickerVariables().left.ampmModel = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_0_Conditional_2_Conditional_13_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.timeChanged($event, ctx_r1.sideEnum.left));
    });
    i0.ɵɵelementStart(2, "option", 27);
    i0.ɵɵtext(3, "AM");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "option", 28);
    i0.ɵɵtext(5, "PM");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "span", 23)(7, "span", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.timepickerVariables().left.ampmModel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.timepickerVariables().left.amDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.timepickerVariables().left.pmDisabled);
  }
}
function CalendarComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 19)(2, "select", 20);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_0_Conditional_2_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.timepickerVariables().left.selectedHour, $event) || (ctx_r1.timepickerVariables().left.selectedHour = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_0_Conditional_2_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.timeChanged($event, ctx_r1.sideEnum.left));
    });
    i0.ɵɵrepeaterCreate(3, CalendarComponent_Conditional_0_Conditional_2_For_4_Template, 2, 3, "option", 21, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(5, " : ");
    i0.ɵɵelementStart(6, "div", 19)(7, "select", 22);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_0_Conditional_2_Template_select_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.timepickerVariables().left.selectedMinute, $event) || (ctx_r1.timepickerVariables().left.selectedMinute = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_0_Conditional_2_Template_select_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.timeChanged($event, ctx_r1.sideEnum.left));
    });
    i0.ɵɵrepeaterCreate(8, CalendarComponent_Conditional_0_Conditional_2_For_9_Template, 2, 3, "option", 21, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "span", 23)(11, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CalendarComponent_Conditional_0_Conditional_2_Conditional_12_Template, 7, 2, "div", 19)(13, CalendarComponent_Conditional_0_Conditional_2_Conditional_13_Template, 8, 3, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.startDate());
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.timepickerVariables().left.selectedHour);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.timepickerVariables().left.hours);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r1.startDate());
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.timepickerVariables().left.selectedMinute);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.timepickerVariables().left.minutes);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.timePickerSeconds() ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.timePicker24Hour() ? 13 : -1);
  }
}
function CalendarComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, CalendarComponent_Conditional_0_Conditional_1_Template, 18, 8, "table", 2)(2, CalendarComponent_Conditional_0_Conditional_2_Template, 14, 6, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c1, ctx_r1.singleDatePicker(), !ctx_r1.singleDatePicker()));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.calendarVariables() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.timePicker() ? 2 : -1);
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 11);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_1_Conditional_1_Conditional_4_Template_th_click_0_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clickPrev($event, ctx_r1.sideEnum.right));
    });
    i0.ɵɵelementEnd();
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_7_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const m_r21 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selected", ctx_r1.calendarVariables().right.dropdowns.currentMonth == m_r21)("value", m_r21)("disabled", ctx_r1.calendarVariables().right.dropdowns.inMinYear && ctx_r1.calendarVariables().right.minDate && m_r21 < ctx_r1.calendarVariables().right.minDate.month() || ctx_r1.calendarVariables().right.dropdowns.inMaxYear && ctx_r1.calendarVariables().right.maxDate && m_r21 > ctx_r1.calendarVariables().right.maxDate.month());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale().monthNames[m_r21], " ");
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_7_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const y_r22 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selected", y_r22 === ctx_r1.calendarVariables().right.dropdowns.currentYear);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", y_r22, " ");
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "select", 13);
    i0.ɵɵlistener("change", function CalendarComponent_Conditional_1_Conditional_1_Conditional_7_Template_select_change_2_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthChanged($event, ctx_r1.sideEnum.right));
    });
    i0.ɵɵrepeaterCreate(3, CalendarComponent_Conditional_1_Conditional_1_Conditional_7_For_4_Template, 2, 4, "option", 14, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 12);
    i0.ɵɵtext(6);
    i0.ɵɵelementStart(7, "select", 15);
    i0.ɵɵlistener("change", function CalendarComponent_Conditional_1_Conditional_1_Conditional_7_Template_select_change_7_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearChanged($event, ctx_r1.sideEnum.right));
    });
    i0.ɵɵrepeaterCreate(8, CalendarComponent_Conditional_1_Conditional_1_Conditional_7_For_9_Template, 2, 2, "option", 16, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale().monthNames[(tmp_3_0 = ctx_r1.calendarVariables().right.calendar) == null ? null : tmp_3_0[1][1].month()], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.calendarVariables().right.dropdowns.monthArrays);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_5_0 = ctx_r1.calendarVariables().right.calendar) == null ? null : tmp_5_0[1][1].format(" YYYY"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.calendarVariables().right.dropdowns.yearArrays);
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate2(" ", ctx_r1.locale().monthNames[(tmp_3_0 = ctx_r1.calendarVariables().right.calendar) == null ? null : tmp_3_0[1][1].month()], " ", (tmp_3_0 = ctx_r1.calendarVariables().right.calendar) == null ? null : tmp_3_0[1][1].format(" YYYY"), " ");
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_1_Conditional_1_Conditional_9_Template_th_click_0_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clickNext($event, ctx_r1.sideEnum.right));
    });
    i0.ɵɵelementEnd();
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 8)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.locale().weekLabel);
  }
}
function CalendarComponent_Conditional_1_Conditional_1_For_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dayofweek_r24 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dayofweek_r24);
  }
}
function CalendarComponent_Conditional_1_Conditional_1_For_17_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 8)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_13_0;
    const row_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_13_0 = ctx_r1.calendarVariables().right.calendar) == null ? null : tmp_13_0[row_r25][0].week());
  }
}
function CalendarComponent_Conditional_1_Conditional_1_For_17_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 8)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_13_0;
    const row_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_13_0 = ctx_r1.calendarVariables().right.calendar) == null ? null : tmp_13_0[row_r25][0].isoWeek());
  }
}
function CalendarComponent_Conditional_1_Conditional_1_For_17_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 18);
    i0.ɵɵlistener("click", function CalendarComponent_Conditional_1_Conditional_1_For_17_For_4_Template_td_click_0_listener($event) {
      const col_r27 = i0.ɵɵrestoreView(_r26).$implicit;
      const row_r25 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clickDate($event, ctx_r1.sideEnum.right, row_r25, col_r27));
    })("mouseenter", function CalendarComponent_Conditional_1_Conditional_1_For_17_For_4_Template_td_mouseenter_0_listener($event) {
      const col_r27 = i0.ɵɵrestoreView(_r26).$implicit;
      const row_r25 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.hoverDate($event, ctx_r1.sideEnum.right, row_r25, col_r27));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_23_0;
    const col_r27 = ctx.$implicit;
    const row_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.calendarVariables().right.classes[row_r25][col_r27]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_23_0 = ctx_r1.calendarVariables().right.calendar) == null ? null : tmp_23_0[row_r25][col_r27].date());
  }
}
function CalendarComponent_Conditional_1_Conditional_1_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, CalendarComponent_Conditional_1_Conditional_1_For_17_Conditional_1_Template, 3, 1, "td", 8)(2, CalendarComponent_Conditional_1_Conditional_1_For_17_Conditional_2_Template, 3, 1, "td", 8);
    i0.ɵɵrepeaterCreate(3, CalendarComponent_Conditional_1_Conditional_1_For_17_For_4_Template, 3, 3, "td", 10, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r25 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.calendarVariables().right.classes[row_r25].classList);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showWeekNumbers() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showISOWeekNumbers() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.calendarVariables().right.calCols);
  }
}
function CalendarComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 2)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, CalendarComponent_Conditional_1_Conditional_1_Conditional_3_Template, 1, 0, "th")(4, CalendarComponent_Conditional_1_Conditional_1_Conditional_4_Template, 1, 0, "th", 4)(5, CalendarComponent_Conditional_1_Conditional_1_Conditional_5_Template, 1, 0, "th");
    i0.ɵɵelementStart(6, "th", 29);
    i0.ɵɵtemplate(7, CalendarComponent_Conditional_1_Conditional_1_Conditional_7_Template, 10, 2)(8, CalendarComponent_Conditional_1_Conditional_1_Conditional_8_Template, 1, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CalendarComponent_Conditional_1_Conditional_1_Conditional_9_Template, 1, 0, "th", 6)(10, CalendarComponent_Conditional_1_Conditional_1_Conditional_10_Template, 1, 0, "th");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tr", 7);
    i0.ɵɵtemplate(12, CalendarComponent_Conditional_1_Conditional_1_Conditional_12_Template, 3, 1, "th", 8);
    i0.ɵɵrepeaterCreate(13, CalendarComponent_Conditional_1_Conditional_1_For_14_Template, 3, 1, "th", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "tbody");
    i0.ɵɵrepeaterCreate(16, CalendarComponent_Conditional_1_Conditional_1_For_17_Template, 5, 4, "tr", 10, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.showWeekNumbers() || ctx_r1.showISOWeekNumbers() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((!ctx_r1.calendarVariables().right.minDate || ctx_r1.calendarVariables().right.minDate.isBefore(ctx_r1.calendarVariables().right.calendar.firstDay)) && !ctx_r1.linkedCalendars() ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!((!ctx_r1.calendarVariables().right.minDate || ctx_r1.calendarVariables().right.minDate.isBefore(ctx_r1.calendarVariables().right.calendar.firstDay)) && !ctx_r1.linkedCalendars()) ? 5 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showDropdowns() && ctx_r1.calendarVariables().right.dropdowns ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.showDropdowns() || !ctx_r1.calendarVariables().right.dropdowns ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.calendarVariables().right.maxDate || ctx_r1.calendarVariables().right.maxDate.isAfter(ctx_r1.calendarVariables().right.calendar.lastDay) && (!ctx_r1.linkedCalendars() || ctx_r1.singleDatePicker() || true) ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(!ctx_r1.calendarVariables().right.maxDate || ctx_r1.calendarVariables().right.maxDate.isAfter(ctx_r1.calendarVariables().right.calendar.lastDay) && (!ctx_r1.linkedCalendars() || ctx_r1.singleDatePicker() || true)) ? 10 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showWeekNumbers() || ctx_r1.showISOWeekNumbers() ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.locale().daysOfWeek);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.calendarVariables().right.calRows);
  }
}
function CalendarComponent_Conditional_1_Conditional_2_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r29 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r29)("disabled", ctx_r1.timepickerVariables().right.disabledHours.indexOf(i_r29) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r29, " ");
  }
}
function CalendarComponent_Conditional_1_Conditional_2_For_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r30 = ctx.$implicit;
    const $index_r31 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r30)("disabled", ctx_r1.timepickerVariables().right.disabledMinutes.indexOf(i_r30) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.timepickerVariables().right.minutesLabel[$index_r31], " ");
  }
}
function CalendarComponent_Conditional_1_Conditional_2_Conditional_14_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r33 = ctx.$implicit;
    const $index_r34 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", i_r33)("disabled", ctx_r1.timepickerVariables().right.disabledSeconds.indexOf(i_r33) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.timepickerVariables().right.secondsLabel[$index_r34], " ");
  }
}
function CalendarComponent_Conditional_1_Conditional_2_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0, " : ");
    i0.ɵɵelementStart(1, "div", 19)(2, "select", 25);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_1_Conditional_2_Conditional_14_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r32);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.timepickerVariables().right.selectedSecond, $event) || (ctx_r1.timepickerVariables().right.selectedSecond = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_1_Conditional_2_Conditional_14_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r32);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.timeChanged($event, ctx_r1.sideEnum.right));
    });
    i0.ɵɵrepeaterCreate(3, CalendarComponent_Conditional_1_Conditional_2_Conditional_14_For_4_Template, 2, 3, "option", 21, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 23)(6, "span", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.startDate());
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.timepickerVariables().right.selectedSecond);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.timepickerVariables().right.seconds);
  }
}
function CalendarComponent_Conditional_1_Conditional_2_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "select", 26);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_1_Conditional_2_Conditional_15_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.timepickerVariables().right.ampmModel, $event) || (ctx_r1.timepickerVariables().right.ampmModel = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_1_Conditional_2_Conditional_15_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.timeChanged($event, ctx_r1.sideEnum.right));
    });
    i0.ɵɵelementStart(2, "option", 27);
    i0.ɵɵtext(3, "AM");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "option", 28);
    i0.ɵɵtext(5, "PM");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "span", 23)(7, "span", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.timepickerVariables().right.ampmModel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.timepickerVariables().right.amDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.timepickerVariables().right.pmDisabled);
  }
}
function CalendarComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 19)(2, "select", 20);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_1_Conditional_2_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.timepickerVariables().right.selectedHour, $event) || (ctx_r1.timepickerVariables().right.selectedHour = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_1_Conditional_2_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.timeChanged($event, ctx_r1.sideEnum.right));
    });
    i0.ɵɵrepeaterCreate(3, CalendarComponent_Conditional_1_Conditional_2_For_4_Template, 2, 3, "option", 21, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 23)(6, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " : ");
    i0.ɵɵelementStart(8, "div", 19)(9, "select", 22);
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarComponent_Conditional_1_Conditional_2_Template_select_ngModelChange_9_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.timepickerVariables().right.selectedMinute, $event) || (ctx_r1.timepickerVariables().right.selectedMinute = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CalendarComponent_Conditional_1_Conditional_2_Template_select_ngModelChange_9_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.timeChanged($event, ctx_r1.sideEnum.right));
    });
    i0.ɵɵrepeaterCreate(10, CalendarComponent_Conditional_1_Conditional_2_For_11_Template, 2, 3, "option", 21, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "span", 23)(13, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CalendarComponent_Conditional_1_Conditional_2_Conditional_14_Template, 7, 2, "div", 19)(15, CalendarComponent_Conditional_1_Conditional_2_Conditional_15_Template, 8, 3, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.startDate());
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.timepickerVariables().right.selectedHour);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.timepickerVariables().right.hours);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", !ctx_r1.startDate());
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.timepickerVariables().right.selectedMinute);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.timepickerVariables().right.minutes);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.timePickerSeconds() ? 14 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.timePicker24Hour() ? 15 : -1);
  }
}
function CalendarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, CalendarComponent_Conditional_1_Conditional_1_Template, 18, 8, "table", 2)(2, CalendarComponent_Conditional_1_Conditional_2_Template, 16, 6, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.calendarVariables() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.timePicker() ? 2 : -1);
  }
}
function ActionsComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ActionsComponent_Conditional_0_Conditional_5_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clickCancel($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale().cancelLabel, " ");
  }
}
function ActionsComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function ActionsComponent_Conditional_0_Conditional_6_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clickClear($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r1.locale().clearLabel);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale().clearLabel, " ");
  }
}
function ActionsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 2);
    i0.ɵɵlistener("click", function ActionsComponent_Conditional_0_Template_button_click_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clickApply($event));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ActionsComponent_Conditional_0_Conditional_5_Template, 2, 1, "button", 3)(6, ActionsComponent_Conditional_0_Conditional_6_Template, 2, 2, "button", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.chosenLabel());
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.applyBtnDisabled());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.locale().applyLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showCancel() ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showClearButton() ? 6 : -1);
  }
}
const _c2 = ["pickerContainer"];
const _c3 = (a0, a1, a2, a3, a4, a5, a6) => ({
  "show-ranges": a0,
  "shown": a1,
  "hidden": a2,
  "double": a3,
  "inline": a4,
  "ltr": a5,
  "rtl": a6
});
dayjs.extend(localeData);
const LOCALE_CONFIG = new InjectionToken('daterangepicker.config');
/**
 *  DefaultLocaleConfig
 */
const DefaultLocaleConfig = {
  direction: 'ltr',
  separator: ' - ',
  weekLabel: 'W',
  applyLabel: 'Apply',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  customRangeLabel: 'Custom range',
  daysOfWeek: dayjs.weekdaysMin(),
  monthNames: dayjs.monthsShort(),
  firstDay: dayjs.localeData().firstDayOfWeek()
};
let NgxDaterangepickerLocaleService = /*#__PURE__*/(() => {
  class NgxDaterangepickerLocaleService {
    _config = inject(LOCALE_CONFIG);
    get config() {
      if (!this._config) {
        return DefaultLocaleConfig;
      }
      return {
        ...DefaultLocaleConfig,
        ...this._config
      };
    }
    static ɵfac = function NgxDaterangepickerLocaleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxDaterangepickerLocaleService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NgxDaterangepickerLocaleService,
      factory: NgxDaterangepickerLocaleService.ɵfac,
      providedIn: 'root'
    });
  }
  return NgxDaterangepickerLocaleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RangesComponent = /*#__PURE__*/(() => {
  class RangesComponent {
    rangesArray = input();
    chosenRange = input();
    locale = input();
    ranges = input();
    minDate = input();
    maxDate = input();
    rangeEvent = output();
    clickRange($event, label) {
      this.rangeEvent.emit({
        $event: $event,
        label: label
      });
    }
    /**
     * Find out if the selected range should be disabled if it doesn't
     * fit into minDate and maxDate limitations.
     */
    disableRange(range) {
      if (range === this.locale().customRangeLabel) {
        return false;
      }
      const rangeMarkers = this.ranges()[range];
      const areBothBefore = rangeMarkers.every(date => {
        if (!this.minDate()) {
          return false;
        }
        return date.isBefore(this.minDate());
      });
      const areBothAfter = rangeMarkers.every(date => {
        if (!this.maxDate()) {
          return false;
        }
        return date.isAfter(this.maxDate());
      });
      return areBothBefore || areBothAfter;
    }
    static ɵfac = function RangesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RangesComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RangesComponent,
      selectors: [["ranges"]],
      inputs: {
        rangesArray: [1, "rangesArray"],
        chosenRange: [1, "chosenRange"],
        locale: [1, "locale"],
        ranges: [1, "ranges"],
        minDate: [1, "minDate"],
        maxDate: [1, "maxDate"]
      },
      outputs: {
        rangeEvent: "rangeEvent"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 1,
      vars: 1,
      consts: [[1, "ranges"], ["type", "button", 3, "click", "disabled", "ngClass"]],
      template: function RangesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, RangesComponent_Conditional_0_Template, 4, 0, "div", 0);
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵconditional(((tmp_0_0 = ctx.rangesArray()) == null ? null : tmp_0_0.length) ? 0 : -1);
        }
      },
      dependencies: [NgClass],
      styles: [".show-ranges[_ngcontent-%COMP%]   .drp-calendar.left[_ngcontent-%COMP%]{border-left:1px solid #ddd}.ranges[_ngcontent-%COMP%]{float:none;text-align:left;margin:0}.ranges[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none;margin:0 auto;padding:0;width:100%}.ranges[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:8px 12px;width:100%;background:none;border:none;border-radius:.375rem;text-align:left;cursor:pointer}.ranges[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button.active[_ngcontent-%COMP%]{background-color:#08c;color:#fff}.ranges[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{opacity:.3}.ranges[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:active{background:transparent}.ranges[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background-color:#eee;border-radius:.375rem}.show-calendar[_ngcontent-%COMP%]   .ranges[_ngcontent-%COMP%]{margin-top:8px}[hidden][_ngcontent-%COMP%]{display:none}"],
      changeDetection: 0
    });
  }
  return RangesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var SideEnum = /*#__PURE__*/function (SideEnum) {
  SideEnum["left"] = "left";
  SideEnum["right"] = "right";
  return SideEnum;
}(SideEnum || {});
let CalendarComponent = /*#__PURE__*/(() => {
  class CalendarComponent {
    sideEnum = SideEnum;
    showCalInRanges = input();
    singleDatePicker = input();
    calendarVariables = input();
    showWeekNumbers = input();
    showISOWeekNumbers = input();
    linkedCalendars = input();
    showDropdowns = input();
    locale = input();
    timePicker = input();
    startDate = input();
    timepickerVariables = input();
    timePickerSeconds = input();
    timePicker24Hour = input();
    prevEvent = output();
    nextEvent = output();
    monthChangedEvent = output();
    yearChangedEvent = output();
    dateEvent = output();
    hoverDateEvent = output();
    timeChangedEvent = output();
    clickPrev($event, side) {
      this.prevEvent.emit({
        $event: $event,
        side: side
      });
    }
    clickNext($event, side) {
      this.nextEvent.emit({
        $event: $event,
        side: side
      });
    }
    monthChanged($event, side) {
      this.monthChangedEvent.emit({
        $event: $event,
        side: side
      });
    }
    yearChanged($event, side) {
      this.yearChangedEvent.emit({
        $event: $event,
        side: side
      });
    }
    clickDate($event, side, row, col) {
      this.dateEvent.emit({
        $event: $event,
        side: side,
        row: row,
        col: col
      });
    }
    hoverDate($event, side, row, col) {
      this.hoverDateEvent.emit({
        $event: $event,
        side: side,
        row: row,
        col: col
      });
    }
    timeChanged($event, side) {
      this.timeChangedEvent.emit({
        $event: $event,
        side: side
      });
    }
    static ɵfac = function CalendarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalendarComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CalendarComponent,
      selectors: [["calendar"]],
      inputs: {
        showCalInRanges: [1, "showCalInRanges"],
        singleDatePicker: [1, "singleDatePicker"],
        calendarVariables: [1, "calendarVariables"],
        showWeekNumbers: [1, "showWeekNumbers"],
        showISOWeekNumbers: [1, "showISOWeekNumbers"],
        linkedCalendars: [1, "linkedCalendars"],
        showDropdowns: [1, "showDropdowns"],
        locale: [1, "locale"],
        timePicker: [1, "timePicker"],
        startDate: [1, "startDate"],
        timepickerVariables: [1, "timepickerVariables"],
        timePickerSeconds: [1, "timePickerSeconds"],
        timePicker24Hour: [1, "timePicker24Hour"]
      },
      outputs: {
        prevEvent: "prevEvent",
        nextEvent: "nextEvent",
        monthChangedEvent: "monthChangedEvent",
        yearChangedEvent: "yearChangedEvent",
        dateEvent: "dateEvent",
        hoverDateEvent: "hoverDateEvent",
        timeChangedEvent: "timeChangedEvent"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 2,
      consts: [[1, "calendar", 3, "ngClass"], [1, "calendar", "right"], [1, "table-condensed", "calendar-table"], [1, "calendar-time"], [1, "prev", "available"], ["colspan", "5", 1, "month", "drp-animate"], [1, "next", "available"], [1, "week-days"], [1, "week"], [1, "drp-animate"], [3, "class"], [1, "prev", "available", 3, "click"], [1, "dropdowns"], [1, "monthselect", 3, "change"], [3, "selected", "value", "disabled"], [1, "yearselect", 3, "change"], [3, "selected"], [1, "next", "available", 3, "click"], [3, "click", "mouseenter"], [1, "select"], [1, "select-item", "hourselect", 3, "ngModelChange", "disabled", "ngModel"], [3, "value", "disabled"], [1, "select-item", "minuteselect", 3, "ngModelChange", "disabled", "ngModel"], [1, "select-highlight"], [1, "select-bar"], [1, "select-item", "secondselect", 3, "ngModelChange", "disabled", "ngModel"], [1, "select-item", "ampmselect", 3, "ngModelChange", "ngModel"], ["value", "AM", 3, "disabled"], ["value", "PM", 3, "disabled"], ["colspan", "5", 1, "month"]],
      template: function CalendarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CalendarComponent_Conditional_0_Template, 3, 6, "div", 0)(1, CalendarComponent_Conditional_1_Template, 3, 2, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.showCalInRanges() ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showCalInRanges() && !ctx.singleDatePicker() ? 1 : -1);
        }
      },
      dependencies: [NgClass, FormsModule, i1.NgSelectOption, i1.ɵNgSelectMultipleOption, i1.SelectControlValueAccessor, i1.NgControlStatus, i1.NgModel],
      styles: [".calendar[_ngcontent-%COMP%]{max-width:270px;margin:4px}.calendar.single[_ngcontent-%COMP%]   .calendar-table[_ngcontent-%COMP%]{border:none}.calendar[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .calendar[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:0;white-space:nowrap;text-align:center;min-width:32px}.calendar[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .calendar[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{pointer-events:none}.calendar-table[_ngcontent-%COMP%]{border:1px solid #fff;padding:4px;border-radius:50%;background-color:#fff}table[_ngcontent-%COMP%]{width:100%;margin:0;border-collapse:separate;border-spacing:1px}th[_ngcontent-%COMP%]{color:#000}td[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{text-align:center;border-radius:50%;white-space:nowrap;cursor:pointer;height:2em;width:2em}td.available.prev[_ngcontent-%COMP%], th.available.prev[_ngcontent-%COMP%]{display:block;background-image:url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K);background-repeat:no-repeat;background-size:.5em;background-position:center;transition:background-color .2s ease;border-radius:50%}td.available.prev[_ngcontent-%COMP%]:hover, th.available.prev[_ngcontent-%COMP%]:hover{margin:0}td.available.next[_ngcontent-%COMP%], th.available.next[_ngcontent-%COMP%]{transform:rotate(180deg);display:block;background-image:url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K);background-repeat:no-repeat;background-size:.5em;background-position:center;transition:background-color .2s ease;border-radius:50%}td.available.next[_ngcontent-%COMP%]:hover, th.available.next[_ngcontent-%COMP%]:hover{margin:0;transform:rotate(180deg)}td.available[_ngcontent-%COMP%]:hover, th.available[_ngcontent-%COMP%]:hover{background-color:#eee;border-color:transparent;color:inherit;background-repeat:no-repeat;background-size:.5em;background-position:center;margin:.25em 0;border-radius:50%;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}td.week[_ngcontent-%COMP%], th.week[_ngcontent-%COMP%]{color:#ccc}td[_ngcontent-%COMP%]{margin:.25em 0;border-radius:50%;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}td.off[_ngcontent-%COMP%], td.off.in-range[_ngcontent-%COMP%], td.off.start-date[_ngcontent-%COMP%], td.off.end-date[_ngcontent-%COMP%]{background-color:#fff;border-color:transparent;color:#999}td.in-range[_ngcontent-%COMP%]{background-color:#ebf4f8;border-color:transparent;color:#000;border-radius:0}td.start-date[_ngcontent-%COMP%]{border-radius:50% 0 0 50%}td.end-date[_ngcontent-%COMP%]{border-radius:0 50% 50% 0}td.start-date.end-date[_ngcontent-%COMP%]{border-radius:50%}td.active[_ngcontent-%COMP%]{transition:background .3s ease-out}td.active[_ngcontent-%COMP%], td.active[_ngcontent-%COMP%]:hover{background-color:#08c;border-color:transparent;color:#fff}th.month[_ngcontent-%COMP%]{width:auto}td.disabled[_ngcontent-%COMP%], option.disabled[_ngcontent-%COMP%]{color:#999;cursor:not-allowed;text-decoration:line-through}.dropdowns[_ngcontent-%COMP%]{background-repeat:no-repeat;background-size:10px;background-position-y:center;background-position-x:right;width:50px;background-image:url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDI1NSAyNTUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1NSAyNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0iYXJyb3ctZHJvcC1kb3duIj4KCQk8cG9seWdvbiBwb2ludHM9IjAsNjMuNzUgMTI3LjUsMTkxLjI1IDI1NSw2My43NSAgICIgZmlsbD0iIzk4OGM4YyIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=)}.dropdowns[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{display:inline-block;background-color:#ffffffe6;width:100%;padding:5px;border:1px solid #f2f2f2;border-radius:calc(.5rem - 1px);height:3rem}.dropdowns[_ngcontent-%COMP%]   select.monthselect[_ngcontent-%COMP%], .dropdowns[_ngcontent-%COMP%]   select.yearselect[_ngcontent-%COMP%]{font-size:12px;padding:1px;height:auto;margin:0;cursor:default}.dropdowns[_ngcontent-%COMP%]   select.hourselect[_ngcontent-%COMP%], .dropdowns[_ngcontent-%COMP%]   select.minuteselect[_ngcontent-%COMP%], .dropdowns[_ngcontent-%COMP%]   select.secondselect[_ngcontent-%COMP%], .dropdowns[_ngcontent-%COMP%]   select.ampmselect[_ngcontent-%COMP%]{width:50px;margin:0 auto;background:#eee;border:1px solid #eee;padding:2px;outline:0;font-size:12px}.dropdowns[_ngcontent-%COMP%]   select.monthselect[_ngcontent-%COMP%], .dropdowns[_ngcontent-%COMP%]   select.yearselect[_ngcontent-%COMP%]{cursor:pointer;opacity:0;position:absolute;top:0;left:0;margin:0;padding:0}th.month[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:relative;display:inline-block}.calendar-time[_ngcontent-%COMP%]{text-align:center;margin:4px auto 0;line-height:30px;position:relative}.calendar-time[_ngcontent-%COMP%]   .select[_ngcontent-%COMP%]{display:inline;border:1px solid #eee;border-radius:calc(.5rem - 1px);background:#eee;padding:3px}.calendar-time[_ngcontent-%COMP%]   .select[_ngcontent-%COMP%]   .select-item[_ngcontent-%COMP%]{display:inline-block;width:auto;position:relative;font-family:inherit;background-color:transparent;padding:0 10px 0 0;border-radius:calc(.5rem - 1px);border:none}.calendar-time[_ngcontent-%COMP%]   .select[_ngcontent-%COMP%]   .select-item[_ngcontent-%COMP%]:after{position:absolute;top:18px;right:10px;width:0;height:0;padding:0;content:\"\";border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid rgba(0,0,0,.12);pointer-events:none}.calendar-time[_ngcontent-%COMP%]   .select[_ngcontent-%COMP%]   .select-item[_ngcontent-%COMP%]:focus{outline:none}.calendar-time[_ngcontent-%COMP%]   .select[_ngcontent-%COMP%]   .select-item[_ngcontent-%COMP%]   .select-label[_ngcontent-%COMP%]{color:#00000042;font-size:16px;font-weight:400;position:absolute;pointer-events:none;left:0;top:10px;transition:.2s ease all}.calendar-time[_ngcontent-%COMP%]   select.disabled[_ngcontent-%COMP%]{color:#ccc;cursor:not-allowed}"],
      changeDetection: 0
    });
  }
  return CalendarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ActionsComponent = /*#__PURE__*/(() => {
  class ActionsComponent {
    rangesArray = input([]);
    autoApply = input();
    showCalInRanges = input();
    singleDatePicker = input();
    chosenLabel = input();
    applyBtnDisabled = input();
    locale = input();
    showCancel = input();
    showClearButton = input();
    applyEvent = output();
    cancelEvent = output();
    clearEvent = output();
    clickApply($event) {
      this.applyEvent.emit($event);
    }
    clickCancel($event) {
      this.cancelEvent.emit($event);
    }
    clickClear($event) {
      this.clearEvent.emit($event);
    }
    static ɵfac = function ActionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ActionsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ActionsComponent,
      selectors: [["actions"]],
      inputs: {
        rangesArray: [1, "rangesArray"],
        autoApply: [1, "autoApply"],
        showCalInRanges: [1, "showCalInRanges"],
        singleDatePicker: [1, "singleDatePicker"],
        chosenLabel: [1, "chosenLabel"],
        applyBtnDisabled: [1, "applyBtnDisabled"],
        locale: [1, "locale"],
        showCancel: [1, "showCancel"],
        showClearButton: [1, "showClearButton"]
      },
      outputs: {
        applyEvent: "applyEvent",
        cancelEvent: "cancelEvent",
        clearEvent: "clearEvent"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 1,
      vars: 1,
      consts: [[1, "card-footer"], [2, "display", "inline-block", "padding", "7px"], ["type", "button", 1, "btn", "btn-primary", "float-end", 3, "click", "disabled"], ["type", "button", 1, "btn", "btn-secondary", "me-2", "float-end"], ["type", "button", 1, "btn", "btn-outline-dark", "me-2", "float-end", 3, "title"], ["type", "button", 1, "btn", "btn-secondary", "me-2", "float-end", 3, "click"], ["type", "button", 1, "btn", "btn-outline-dark", "me-2", "float-end", 3, "click", "title"]],
      template: function ActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ActionsComponent_Conditional_0_Template, 7, 5, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.autoApply() && (!ctx.rangesArray().length || ctx.showCalInRanges() && !ctx.singleDatePicker()) ? 0 : -1);
        }
      },
      changeDetection: 0
    });
  }
  return ActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
dayjs.extend(localeData);
dayjs.extend(LocalizedFormat);
dayjs.extend(isoWeek);
dayjs.extend(week);
dayjs.extend(customParseFormat);
let NgxDaterangepickerBootstrapComponent = /*#__PURE__*/(() => {
  class NgxDaterangepickerBootstrapComponent {
    _localeService = inject(NgxDaterangepickerLocaleService);
    $event;
    chosenLabel;
    calendarVariables = {
      left: {},
      right: {}
    };
    timepickerVariables = {
      left: {},
      right: {}
    };
    applyBtnDisabled = signal(false);
    chosenRange;
    rangesArray = [];
    inline = true;
    showCalInRanges = false;
    tooltiptext = []; // for storing tooltiptext
    leftCalendar = {};
    rightCalendar = {};
    nowHoveredDate = null;
    pickingDate = false;
    _old = {
      start: null,
      end: null
    };
    _minDate;
    _maxDate;
    // private _locale: LocaleConfig = {};
    _ranges = {};
    startDate = model(dayjs().startOf('day'));
    endDate = model(dayjs().endOf('day'));
    dateLimit = input(null);
    autoApply = input(false);
    singleDatePicker = input(false);
    showDropdowns = input(false);
    showWeekNumbers = input(false);
    showISOWeekNumbers = input(false);
    linkedCalendars = input(false);
    autoUpdateInput = input(true);
    alwaysShowCalendars = input(false);
    maxSpan = input(false);
    lockStartDate = input(false);
    timePicker = input(false);
    timePicker24Hour = input(false);
    timePickerIncrement = input(1);
    timePicker24HourInterval = input([0, 23]);
    timePickerSeconds = input(false);
    showClearButton = input(false);
    firstMonthDayClass = input(null);
    lastMonthDayClass = input(null);
    emptyWeekRowClass = input(null);
    emptyWeekColumnClass = input(null);
    firstDayOfNextMonthClass = input(null);
    lastDayOfPreviousMonthClass = input(null);
    showCustomRangeLabel = input();
    showCancel = input(false);
    keepCalendarOpeningWithRange = input(false);
    showRangeLabelOnInput = input(false);
    customRangeDirection = input(false);
    drops = input();
    opens = input();
    closeOnAutoApply = input(true);
    minDate = input(undefined, {
      transform: value => {
        dayjs.isDayjs(value) ? this._minDate = value : this._minDate = dayjs(value);
        return this._minDate;
      }
    });
    maxDate = input(undefined, {
      transform: value => {
        dayjs.isDayjs(value) ? this._maxDate = value : this._maxDate = dayjs(value);
        return this._maxDate;
      }
    });
    locale = model({});
    _locale = computed(() => this.locale() !== null ? {
      ...this._localeService.config,
      ...this.locale()
    } : {});
    ranges = input({}, {
      transform: value => {
        this._ranges = value;
        this.renderRanges();
        return this._ranges;
      }
    });
    isInvalidDate = input(() => false);
    isCustomDate = input(() => false);
    isTooltipDate = input(() => null);
    isShown = signal(false);
    pickerContainer = viewChild('pickerContainer');
    chosenDate = output();
    rangeClicked = output();
    datesUpdated = output();
    startDateChanged = output();
    endDateChanged = output();
    cancelClicked = output();
    clearClicked = output();
    constructor() {
      effect(() => {
        this.updateView();
      });
    }
    ngOnInit() {
      this._buildLocale();
      const daysOfWeek = [...this._locale().daysOfWeek];
      this._locale().firstDay = this._locale().firstDay % 7;
      if (this._locale().firstDay !== 0) {
        let iterator = this._locale().firstDay;
        while (iterator > 0) {
          daysOfWeek.push(daysOfWeek.shift());
          iterator--;
        }
      }
      this._locale().daysOfWeek = daysOfWeek;
      if (this.inline) {
        this.applyBtnDisabled.set(true);
        this._old.start = this.startDate()?.clone();
        this._old.end = this.endDate()?.clone();
      }
      const timePicker = this.timePicker();
      if (this.startDate() && timePicker) {
        this.setStartDate(this.startDate());
        this.renderTimePicker(SideEnum.left);
      }
      if (this.endDate() && timePicker) {
        this.setEndDate(this.endDate());
        this.renderTimePicker(SideEnum.right);
      }
      this.updateMonthsInView();
      this.renderCalendar(SideEnum.left);
      this.renderCalendar(SideEnum.right);
      this.renderRanges();
    }
    renderRanges() {
      this.rangesArray = [];
      let start, end;
      if (typeof this.ranges() === 'object') {
        for (const range in this.ranges()) {
          if (this.ranges()[range]) {
            if (typeof this.ranges()[range][0] === 'string') {
              start = dayjs(this.ranges()[range][0], this._locale().format);
            } else {
              start = dayjs(this.ranges()[range][0]);
            }
            if (typeof this.ranges()[range][1] === 'string') {
              end = dayjs(this.ranges()[range][1], this._locale().format);
            } else {
              end = dayjs(this.ranges()[range][1]);
            }
            // If the start or end date exceed those allowed by the minDate or maxSpan
            // options, shorten the range to the allowable period.
            if (this.minDate() && start.isBefore(this.minDate())) {
              start = this.minDate()?.clone();
            }
            let maxDate = this.maxDate();
            const maxSpan = this.maxSpan();
            if (maxSpan && maxDate && start.clone().add(maxSpan).isAfter(maxDate)) {
              maxDate = start.clone().add(maxSpan);
            }
            if (maxDate && end.isAfter(maxDate)) {
              end = maxDate.clone();
            }
            // If the end of the range is before the minimum or the start of the range is
            // after the maximum, don't display this range option at all.
            const timePicker = this.timePicker();
            if (this.minDate() && end.isBefore(this.minDate(), timePicker ? 'minute' : 'day') || maxDate && start.isAfter(maxDate, timePicker ? 'minute' : 'day')) {
              continue;
            }
            // Support unicode chars in the range names.
            const elem = document.createElement('textarea');
            elem.innerHTML = range;
            const rangeHtml = elem.value;
            this.ranges()[rangeHtml] = [start, end];
          }
        }
        for (const range in this.ranges()) {
          if (this.ranges()[range]) {
            this.rangesArray.push(range);
          }
        }
        if (this.showCustomRangeLabel()) {
          this.rangesArray.push(this._locale().customRangeLabel);
        }
        this.showCalInRanges = !this.rangesArray.length || this.alwaysShowCalendars();
        if (!this.timePicker()) {
          this.startDate.set(this.startDate()?.startOf('day'));
          this.endDate.set(this.endDate()?.endOf('day'));
        }
      }
    }
    renderTimePicker(side) {
      let selected, minDate;
      const maxDate = this.maxDate();
      if (side === SideEnum.left) {
        selected = this.startDate()?.clone();
        minDate = this.minDate();
      } else if (side === SideEnum.right && this.endDate()) {
        selected = this.endDate()?.clone();
        minDate = this.startDate();
      } else if (side === SideEnum.right && !this.endDate()) {
        // don't have an end date, use the start date then put the selected time for the right side as the time
        selected = this._getDateWithTime(this.startDate(), SideEnum.right);
        if (selected.isBefore(this.startDate())) {
          selected = this.startDate()?.clone(); // set it back to the start date the time was backwards
        }
        minDate = this.startDate();
      }
      const start = this.timePicker24Hour() ? this.timePicker24HourInterval()[0] : 1;
      const end = this.timePicker24Hour() ? this.timePicker24HourInterval()[1] : 12;
      this.timepickerVariables[side] = {
        hours: [],
        minutes: [],
        minutesLabel: [],
        seconds: [],
        secondsLabel: [],
        disabledHours: [],
        disabledMinutes: [],
        disabledSeconds: [],
        selectedHour: 0,
        selectedMinute: 0,
        selectedSecond: 0
      };
      // generate hours
      for (let i = start; i <= end; i++) {
        let i_in_24 = i;
        if (!this.timePicker24Hour()) {
          i_in_24 = selected.hour() >= 12 ? i === 12 ? 12 : i + 12 : i === 12 ? 0 : i;
        }
        const time = selected.clone().hour(i_in_24);
        let disabled = false;
        if (minDate && time.minute(59).isBefore(minDate)) {
          disabled = true;
        }
        if (maxDate && time.minute(0).isAfter(maxDate)) {
          disabled = true;
        }
        this.timepickerVariables[side].hours.push(i);
        if (i_in_24 === selected.hour() && !disabled) {
          this.timepickerVariables[side].selectedHour = i;
        } else if (disabled) {
          this.timepickerVariables[side].disabledHours.push(i);
        }
      }
      // generate minutes
      for (let i = 0; i < 60; i += this.timePickerIncrement()) {
        const padded = i < 10 ? '0' + i : i;
        const time = selected.clone().minute(i);
        let disabled = false;
        if (minDate && time.second(59).isBefore(minDate)) {
          disabled = true;
        }
        if (maxDate && time.second(0).isAfter(maxDate)) {
          disabled = true;
        }
        this.timepickerVariables[side].minutes.push(i);
        this.timepickerVariables[side].minutesLabel.push(padded);
        if (selected.minute() === i && !disabled) {
          this.timepickerVariables[side].selectedMinute = i;
        } else if (disabled) {
          this.timepickerVariables[side].disabledMinutes.push(i);
        }
      }
      // generate seconds
      if (this.timePickerSeconds()) {
        for (let i = 0; i < 60; i++) {
          const padded = i < 10 ? '0' + i : i;
          const time = selected.clone().second(i);
          let disabled = false;
          if (minDate && time.isBefore(minDate)) {
            disabled = true;
          }
          if (maxDate && time.isAfter(maxDate)) {
            disabled = true;
          }
          this.timepickerVariables[side].seconds.push(i);
          this.timepickerVariables[side].secondsLabel.push(padded);
          if (selected.second() === i && !disabled) {
            this.timepickerVariables[side].selectedSecond = i;
          } else if (disabled) {
            this.timepickerVariables[side].disabledSeconds.push(i);
          }
        }
      }
      // generate AM/PM
      if (!this.timePicker24Hour()) {
        if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) {
          this.timepickerVariables[side].amDisabled = true;
        }
        if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) {
          this.timepickerVariables[side].pmDisabled = true;
        }
        if (selected.hour() >= 12) {
          this.timepickerVariables[side].ampmModel = 'PM';
        } else {
          this.timepickerVariables[side].ampmModel = 'AM';
        }
      }
      this.timepickerVariables[side].selected = selected;
    }
    renderCalendar(side) {
      const mainCalendar = side === SideEnum.left ? this.leftCalendar : this.rightCalendar;
      const month = mainCalendar.month.month();
      const year = mainCalendar.month.year();
      const hour = mainCalendar.month.hour();
      const minute = mainCalendar.month.minute();
      const second = mainCalendar.month.second();
      const daysInMonth = dayjs(new Date(year, month)).daysInMonth();
      const firstDay = dayjs(new Date(year, month, 1));
      const lastDay = dayjs(new Date(year, month, daysInMonth));
      const lastMonth = dayjs(firstDay).subtract(1, 'month').month();
      const lastYear = dayjs(firstDay).subtract(1, 'month').year();
      const daysInLastMonth = dayjs(new Date(lastYear, lastMonth)).daysInMonth();
      const dayOfWeek = firstDay.day();
      // initialize a 6 rows x 7 columns array for the calendar
      const calendar = [];
      calendar.firstDay = firstDay;
      calendar.lastDay = lastDay;
      for (let i = 0; i < 6; i++) calendar[i] = [];
      // populate the calendar with date objects
      let startDay = daysInLastMonth - dayOfWeek + this._locale().firstDay + 1;
      if (startDay > daysInLastMonth) startDay -= 7;
      if (dayOfWeek === this._locale().firstDay) startDay = daysInLastMonth - 6;
      let curDate = dayjs(new Date(lastYear, lastMonth, startDay, 12, minute, second));
      for (let i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = dayjs(curDate).add(24, 'hour')) {
        if (i > 0 && col % 7 === 0) {
          col = 0;
          row++;
        }
        calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
        curDate = curDate.hour(12);
        if (this.minDate() && calendar[row][col].format('YYYY-MM-DD') === this.minDate()?.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate()) && side === 'left') {
          calendar[row][col] = this.minDate()?.clone();
        }
        if (this.maxDate() && calendar[row][col].format('YYYY-MM-DD') === this.maxDate()?.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate()) && side === 'right') {
          calendar[row][col] = this.maxDate()?.clone();
        }
      }
      // make the calendar object available to hoverDate/clickDate
      if (side === SideEnum.left) {
        this.leftCalendar.calendar = calendar;
      } else {
        this.rightCalendar.calendar = calendar;
      }
      //
      // Display the calendar
      //
      let minDate = side === 'left' ? this.minDate() : this.startDate();
      let maxDate = this.maxDate();
      // adjust maxDate to reflect the dateLimit setting in order to
      // grey out end dates beyond the dateLimit
      const dateLimit = this.dateLimit();
      if (this.endDate() === null && dateLimit) {
        const maxLimit = this.startDate()?.clone().add(dateLimit, 'day').endOf('day');
        if (!maxDate || maxLimit?.isBefore(maxDate)) maxDate = maxLimit;
        if (this.customRangeDirection()) {
          minDate = this.minDate();
          const minLimit = this.startDate()?.clone().subtract(dateLimit, 'day').endOf('day');
          if (!minDate || minLimit?.isAfter(minDate)) {
            minDate = minLimit;
          }
        }
      }
      this.calendarVariables[side] = {
        month: month,
        year: year,
        hour: hour,
        minute: minute,
        second: second,
        daysInMonth: daysInMonth,
        firstDay: firstDay,
        lastDay: lastDay,
        lastMonth: lastMonth,
        lastYear: lastYear,
        daysInLastMonth: daysInLastMonth,
        dayOfWeek: dayOfWeek,
        // other vars
        calRows: Array.from(Array(6).keys()),
        calCols: Array.from(Array(7).keys()),
        classes: {},
        minDate: minDate,
        maxDate: maxDate,
        calendar: calendar
      };
      if (this.showDropdowns()) {
        const currentMonth = calendar[1][1].month();
        const currentYear = calendar[1][1].year();
        const realCurrentYear = dayjs().year();
        const maxYear = maxDate && maxDate.year() || realCurrentYear + 5;
        const minYear = minDate && minDate.year() || realCurrentYear - 50;
        const inMinYear = currentYear === minYear;
        const inMaxYear = currentYear === maxYear;
        const years = [];
        for (let y = minYear; y <= maxYear; y++) years.push(y);
        this.calendarVariables[side].dropdowns = {
          currentMonth: currentMonth,
          currentYear: currentYear,
          maxYear: maxYear,
          minYear: minYear,
          inMinYear: inMinYear,
          inMaxYear: inMaxYear,
          monthArrays: Array.from(Array(12).keys()),
          yearArrays: years
        };
      }
      this._buildCells(calendar, side);
    }
    setStartDate(startDate) {
      if (typeof startDate === 'string') this.startDate.set(dayjs(startDate, this._locale().format));
      if (typeof startDate === 'object') {
        this.pickingDate = true;
        this.startDate.set(dayjs(startDate));
      }
      const timePicker = this.timePicker();
      if (!timePicker) {
        this.pickingDate = true;
        this.startDate.set(this.startDate()?.startOf('day'));
      }
      const timePickerIncrement = this.timePickerIncrement();
      if (timePicker && timePickerIncrement) {
        this.startDate.set(this.startDate()?.minute(Math.round(this.startDate().minute() / timePickerIncrement) * timePickerIncrement));
      }
      if (this.minDate() && this.startDate()?.isBefore(this.minDate())) {
        this.startDate.set(this.minDate()?.clone());
        if (timePicker && timePickerIncrement) {
          this.startDate.set(this.startDate()?.minute(Math.round(this.startDate().minute() / timePickerIncrement) * timePickerIncrement));
        }
      }
      if (this.maxDate() && this.startDate()?.isAfter(this.maxDate())) {
        this.startDate.set(this.maxDate()?.clone());
        if (timePicker && timePickerIncrement) {
          this.startDate.set(this.startDate()?.minute(Math.floor(this.startDate().minute() / timePickerIncrement) * timePickerIncrement));
        }
      }
      if (!this.isShown()) {
        this.updateElement();
      }
      this.startDateChanged.emit({
        startDate: this.startDate()
      });
      this.updateMonthsInView();
    }
    setEndDate(endDate) {
      if (typeof endDate === 'string') {
        this.endDate.set(dayjs(endDate, this._locale().format));
      }
      if (typeof endDate === 'object') {
        this.pickingDate = false;
        this.endDate.set(dayjs(endDate));
      }
      const timePicker = this.timePicker();
      if (!timePicker) {
        this.pickingDate = false;
        this.endDate.set(this.endDate()?.add(1, 'd').startOf('day').subtract(1, 'second'));
      }
      const timePickerIncrement = this.timePickerIncrement();
      if (timePicker && timePickerIncrement) {
        this.endDate()?.minute(Math.round(this.endDate().minute() / timePickerIncrement) * timePickerIncrement);
      }
      if (this.endDate()?.isBefore(this.startDate())) {
        this.endDate.set(this.startDate()?.clone());
      }
      if (this.maxDate() && this.endDate()?.isAfter(this.maxDate())) {
        this.endDate.set(this.maxDate()?.clone());
      }
      const dateLimit = this.dateLimit();
      if (dateLimit && this.startDate()?.clone().add(dateLimit, 'day').isBefore(this.endDate())) {
        this.endDate.set(this.startDate().clone().add(dateLimit, 'day'));
      }
      if (!this.isShown()) {
        // this.updateElement();
      }
      this.endDateChanged.emit({
        endDate: this.endDate()
      });
      this.updateMonthsInView();
    }
    updateView() {
      if (this.timePicker()) {
        this.renderTimePicker(SideEnum.left);
        this.renderTimePicker(SideEnum.right);
      }
      this.updateMonthsInView();
      this.updateCalendars();
    }
    updateMonthsInView() {
      const singleDatePicker = this.singleDatePicker();
      const linkedCalendars = this.linkedCalendars();
      if (this.endDate()) {
        // if both dates are visible already, do nothing
        if (!singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate() && this.leftCalendar && this.startDate()?.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') || this.startDate() && this.rightCalendar && this.startDate()?.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM')) && (this.endDate()?.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') || this.endDate()?.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM'))) {
          return;
        }
        if (this.startDate()) {
          this.leftCalendar.month = this.startDate()?.clone().date(2);
          if (!linkedCalendars && (this.endDate()?.month() !== this.startDate()?.month() || this.endDate()?.year() !== this.startDate()?.year())) {
            this.rightCalendar.month = this.endDate()?.clone().date(2);
          } else {
            this.rightCalendar.month = this.startDate()?.clone().date(2).add(1, 'month');
          }
        }
      } else {
        if (this.leftCalendar.month.format('YYYY-MM') !== this.startDate()?.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') !== this.startDate()?.format('YYYY-MM')) {
          this.leftCalendar.month = this.startDate()?.clone().date(2);
          this.rightCalendar.month = this.startDate()?.clone().date(2).add(1, 'month');
        }
      }
      if (this.maxDate() && linkedCalendars && !singleDatePicker && this.rightCalendar.month > this.maxDate()) {
        this.rightCalendar.month = this.maxDate()?.clone().date(2);
        this.leftCalendar.month = this.maxDate()?.clone().date(2).subtract(1, 'month');
      }
    }
    /**
     *  This is responsible for updating the calendars
     */
    updateCalendars() {
      this.renderCalendar(SideEnum.left);
      this.renderCalendar(SideEnum.right);
      if (this.endDate() === null) {
        return;
      }
      this.calculateChosenLabel();
    }
    updateElement() {
      const format = this._locale().displayFormat ? this._locale().displayFormat : this._locale().format;
      const autoUpdateInput = this.autoUpdateInput();
      if (!this.singleDatePicker() && autoUpdateInput) {
        if (this.startDate() && this.endDate()) {
          // if we use ranges and should show range label on input
          if (this.rangesArray.length && this.showRangeLabelOnInput() && this.chosenRange && this._locale().customRangeLabel !== this.chosenRange) {
            this.chosenLabel = this.chosenRange;
          } else {
            this.chosenLabel = this.startDate()?.format(format) + this._locale().separator + this.endDate()?.format(format);
          }
        }
      } else if (autoUpdateInput) {
        this.chosenLabel = this.startDate()?.format(format);
      }
    }
    remove() {
      this.isShown.set(false);
    }
    /**
     * this should calculate the label
     */
    calculateChosenLabel() {
      if (!this._locale() || !this._locale().separator) {
        this._buildLocale();
      }
      let customRange = true;
      let i = 0;
      if (this.rangesArray.length > 0) {
        for (const range in this.ranges()) {
          if (this.ranges()[range]) {
            if (this.timePicker()) {
              const format = this.timePickerSeconds() ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm';
              // ignore times when comparing dates if time picker seconds is not enabled
              if (this.startDate()?.format(format) === this.ranges()[range][0].format(format) && this.endDate()?.format(format) === this.ranges()[range][1].format(format)) {
                customRange = false;
                this.chosenRange = this.rangesArray[i];
                break;
              }
            } else {
              // ignore times when comparing dates if time picker is not enabled
              if (this.startDate()?.format('YYYY-MM-DD') === this.ranges()[range][0].format('YYYY-MM-DD') && this.endDate()?.format('YYYY-MM-DD') === this.ranges()[range][1].format('YYYY-MM-DD')) {
                customRange = false;
                this.chosenRange = this.rangesArray[i];
                break;
              }
            }
            i++;
          }
        }
        if (customRange) {
          if (this.showCustomRangeLabel()) {
            this.chosenRange = this._locale().customRangeLabel;
          } else {
            this.chosenRange = null;
          }
          // if custom label: show calendar
          this.showCalInRanges = true;
        }
      }
      this.updateElement();
    }
    clickApply(e) {
      if (this.inline) this.applyBtnDisabled.set(true);
      if (!this.singleDatePicker() && this.startDate() && !this.endDate()) {
        this.endDate.set(this._getDateWithTime(this.startDate(), SideEnum.right));
        this.calculateChosenLabel();
      }
      if (this.startDate() && this.endDate()) {
        // get if there are invalid date between range
        let date = this.startDate()?.clone();
        while (date?.isBefore(this.endDate())) {
          if (this.isInvalidDate()(date)) {
            this.endDate.set(date.subtract(1, 'days'));
            this.calculateChosenLabel();
            break;
          }
          date = date.add(1, 'days');
        }
      }
      if (this.chosenLabel) {
        this.chosenDate.emit({
          chosenLabel: this.chosenLabel,
          startDate: this.startDate(),
          endDate: this.endDate()
        });
      }
      this.datesUpdated.emit({
        startDate: this.startDate(),
        endDate: this.endDate(),
        label: this.chosenRange
      });
      if (e || this.closeOnAutoApply() && !e) {
        this.hide();
      }
    }
    clickCancel(e) {
      this.startDate.set(this._old.start);
      this.endDate.set(this._old.end);
      if (this.inline) {
        this.updateView();
      }
      this.cancelClicked.emit();
      this.hide();
      this.clearIncompleteDateSelection();
    }
    /**
     * called when month is changed
     * @param object get month value in $event.target.value / side left or right
     */
    monthChanged(object) {
      const {
        $event,
        side
      } = object;
      const year = this.calendarVariables[side].dropdowns.currentYear;
      const month = parseInt($event.target.value, 10);
      this.monthOrYearChanged(month, year, side);
    }
    /**
     * called when year is changed
     * @param object get year value in $event.target.value / side left or right
     */
    yearChanged(object) {
      const {
        $event,
        side
      } = object;
      const month = this.calendarVariables[side].dropdowns.currentMonth;
      const year = parseInt($event.target.value, 10);
      this.monthOrYearChanged(month, year, side);
    }
    /**
     * called when time is changed
     * @param object time $event / side left or right
     */
    timeChanged(object) {
      const {
        $event,
        side
      } = object;
      let hour = parseInt(this.timepickerVariables[side].selectedHour, 10);
      const minute = parseInt(this.timepickerVariables[side].selectedMinute, 10);
      const second = this.timePickerSeconds() ? parseInt(this.timepickerVariables[side].selectedSecond, 10) : 0;
      if (!this.timePicker24Hour()) {
        const ampm = this.timepickerVariables[side].ampmModel;
        if (ampm === 'PM' && hour < 12) {
          hour += 12;
        }
        if (ampm === 'AM' && hour === 12) {
          hour = 0;
        }
      }
      if (side === SideEnum.left) {
        let start = this.startDate()?.clone();
        start = start?.hour(hour);
        start = start?.minute(minute);
        start = start?.second(second);
        this.setStartDate(start);
        this.setEndDate(this.endDate()?.clone());
        if (this.singleDatePicker()) {
          this.endDate.set(this.startDate()?.clone());
        } else if (this.endDate() && this.endDate()?.format('YYYY-MM-DD') === start?.format('YYYY-MM-DD') && this.endDate()?.isBefore(start)) {
          this.setEndDate(start?.clone());
        } else if (!this.endDate() && this.timePicker()) {
          const startClone = this._getDateWithTime(start, SideEnum.right);
          if (startClone.isBefore(start)) {
            this.timepickerVariables[SideEnum.right].selectedHour = hour;
            this.timepickerVariables[SideEnum.right].selectedMinute = minute;
            this.timepickerVariables[SideEnum.right].selectedSecond = second;
          }
        }
      } else if (this.endDate()) {
        this.setStartDate(this.startDate()?.clone());
        let end = this.endDate()?.clone();
        end = end?.hour(hour);
        end = end?.minute(minute);
        end = end?.second(second);
        this.setEndDate(end);
      }
      // update the calendars so all clickable dates reflect the new time component
      this.updateCalendars();
      // re-render the time pickers because changing one selection can affect what's enabled in another
      this.renderTimePicker(SideEnum.left);
      this.renderTimePicker(SideEnum.right);
      if (this.autoApply()) {
        this.clickApply();
      }
      this.applyBtnDisabled.set(false);
    }
    /**
     *  call when month or year changed
     * @param month month number 0 -11
     * @param year year eg: 1995
     * @param side left or right
     */
    monthOrYearChanged(month, year, side) {
      const isLeft = side === SideEnum.left;
      if (!isLeft) {
        if (year < this.startDate().year() || year === this.startDate().year() && month < this.startDate().month()) {
          month = this.startDate().month();
          year = this.startDate().year();
        }
      }
      if (this.minDate()) {
        if (year < this.minDate().year() || year === this.minDate().year() && month < this.minDate().month()) {
          month = this.minDate().month();
          year = this.minDate().year();
        }
      }
      if (this.maxDate()) {
        if (year > this.maxDate().year() || year === this.maxDate().year() && month > this.maxDate().month()) {
          month = this.maxDate().month();
          year = this.maxDate().year();
        }
      }
      this.calendarVariables[side].dropdowns.currentYear = year;
      this.calendarVariables[side].dropdowns.currentMonth = month;
      if (isLeft) {
        this.leftCalendar.month = this.leftCalendar.month.month(month).year(year);
        if (this.linkedCalendars()) {
          this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
        }
      } else {
        this.rightCalendar.month = this.rightCalendar.month.month(month).year(year);
        if (this.linkedCalendars()) {
          this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
        }
      }
      this.updateCalendars();
    }
    /**
     * Click on previous month
     * @param object previous $event / side left or right calendar
     */
    clickPrev(object) {
      const {
        $event,
        side
      } = object;
      if (side === SideEnum.left) {
        this.leftCalendar.month = this.leftCalendar.month.subtract(1, 'month');
        if (this.linkedCalendars()) {
          this.rightCalendar.month = this.rightCalendar.month.subtract(1, 'month');
        }
      } else {
        this.rightCalendar.month = this.rightCalendar.month.subtract(1, 'month');
      }
      this.updateCalendars();
    }
    /**
     * Click on next month
     * @param object next $event / side left or right calendar
     */
    clickNext(object) {
      const {
        $event,
        side
      } = object;
      if (side === SideEnum.left) {
        this.leftCalendar.month = this.leftCalendar.month.add(1, 'month');
      } else {
        this.rightCalendar.month = this.rightCalendar.month.add(1, 'month');
        if (this.linkedCalendars()) {
          this.leftCalendar.month = this.leftCalendar.month.add(1, 'month');
        }
      }
      this.updateCalendars();
    }
    /**
     * When hovering a date
     * @param object get value by $event.target.value / side left or right / row or col position of the current date clicked
     */
    hoverDate(object) {
      const {
        $event,
        side,
        row,
        col
      } = object;
      const leftCalDate = this.calendarVariables.left.calendar[row][col];
      const rightCalDate = this.calendarVariables.right.calendar[row][col];
      if (this.pickingDate) {
        this.nowHoveredDate = side === SideEnum.left ? leftCalDate : rightCalDate;
        this.renderCalendar(SideEnum.left);
        this.renderCalendar(SideEnum.right);
      }
      const tooltip = side === SideEnum.left ? this.tooltiptext[leftCalDate] : this.tooltiptext[rightCalDate];
      if (tooltip.length > 0) {
        $event.target.setAttribute('title', tooltip);
      }
    }
    /**
     * When selecting a date
     * @param object get value by $event.target.value / side left or right / row or col position of the current date clicked
     */
    clickDate(object) {
      const {
        $event,
        side,
        row,
        col
      } = object;
      if ($event.target.tagName === 'TD') {
        if (!$event.target.classList.contains('available')) return;
      } else if ($event.target.tagName === 'SPAN') {
        if (!$event.target.parentElement.classList.contains('available')) return;
      }
      if (this.rangesArray.length) {
        this.chosenRange = this._locale().customRangeLabel;
      }
      let date = side === SideEnum.left ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
      const customRangeDirection = this.customRangeDirection();
      const autoApply = this.autoApply();
      if ((this.endDate() || date.isBefore(this.startDate(), 'day') && !customRangeDirection) && !this.lockStartDate()) {
        // picking start
        this.applyBtnDisabled.set(true);
        if (this.timePicker()) {
          date = this._getDateWithTime(date, SideEnum.left);
        }
        this.endDate.set(null);
        this.setStartDate(date.clone());
      } else if (!this.endDate() && date.isBefore(this.startDate()) && !customRangeDirection) {
        // special case: clicking the same date for start/end,
        // but the time of the end date is before the start date
        this.setEndDate(this.startDate()?.clone());
      } else {
        // picking end
        this.applyBtnDisabled.set(false);
        if (this.timePicker()) {
          date = this._getDateWithTime(date, SideEnum.right);
        }
        if (date.isBefore(this.startDate(), 'day') === true && customRangeDirection) {
          this.setEndDate(this.startDate());
          this.setStartDate(date.clone());
        } else {
          this.setEndDate(date.clone());
        }
        if (autoApply) {
          this.calculateChosenLabel();
        }
      }
      if (this.singleDatePicker()) {
        this.applyBtnDisabled.set(false);
        this.setEndDate(this.startDate());
        this.updateElement();
      }
      this.updateView();
      if (autoApply && this.startDate() && this.endDate()) {
        this.clickApply();
      }
      // This is to cancel the blur event handler if the mouse was in one of the inputs
      $event.stopPropagation();
    }
    /**
     *  Click on the custom range
     * @param object $event / label
     */
    clickRange(object) {
      const {
        $event,
        label
      } = object;
      this.chosenRange = label;
      if (label === this._locale().customRangeLabel) {
        this.isShown.set(true); // show calendars
        this.showCalInRanges = true;
        // disable apply button after selecting custom range
        this.applyBtnDisabled.set(true);
      } else {
        const dates = this.ranges()[label];
        this.startDate.set(dates[0].clone());
        this.endDate.set(dates[1].clone());
        if (this.showRangeLabelOnInput() && label !== this._locale().customRangeLabel) {
          this.chosenLabel = label;
        } else {
          this.calculateChosenLabel();
        }
        this.showCalInRanges = !this.rangesArray.length || this.alwaysShowCalendars();
        const timePicker = this.timePicker();
        if (!timePicker) {
          this.startDate.set(this.startDate()?.startOf('day'));
          this.endDate.set(this.endDate()?.endOf('day'));
        }
        const alwaysShowCalendars = this.alwaysShowCalendars();
        if (!alwaysShowCalendars) {
          this.isShown.set(false); // hide calendars
        }
        this.rangeClicked.emit({
          label: label,
          dates: dates
        });
        if (!this.keepCalendarOpeningWithRange() || this.autoApply()) {
          this.clickApply();
        } else {
          if (!alwaysShowCalendars) {
            return this.clickApply();
          }
          if (this.maxDate() && this.maxDate()?.isSame(dates[0], 'month')) {
            this.rightCalendar.month = this.rightCalendar.month.month(dates[0].month());
            this.rightCalendar.month = this.rightCalendar.month.year(dates[0].year());
            this.leftCalendar.month = this.leftCalendar.month.month(dates[0].month() - 1);
            this.leftCalendar.month = this.leftCalendar.month.year(dates[1].year());
          } else {
            this.leftCalendar.month = this.leftCalendar.month.month(dates[0].month());
            this.leftCalendar.month = this.leftCalendar.month.year(dates[0].year());
            // get the next year
            const nextMonth = dates[0].clone().add(1, 'month');
            this.rightCalendar.month = this.rightCalendar.month.month(nextMonth.month());
            this.rightCalendar.month = this.rightCalendar.month.year(nextMonth.year());
          }
          this.updateCalendars();
          if (timePicker) {
            this.renderTimePicker(SideEnum.left);
            this.renderTimePicker(SideEnum.right);
          }
          // enable apply button after selecting a range
          this.applyBtnDisabled.set(false);
        }
      }
    }
    show(e) {
      if (this.isShown()) return;
      this._old.start = this.startDate()?.clone();
      this._old.end = this.endDate()?.clone();
      this.isShown.set(true);
      this.applyBtnDisabled.set(true);
      this.updateView();
    }
    hide(e) {
      if (!this.isShown()) return;
      // incomplete date selection, revert to last values
      if (!this.endDate()) {
        if (this._old.start) this.startDate.set(this._old.start.clone());
        if (this._old.end) this.endDate.set(this._old.end.clone());
        this.clearIncompleteDateSelection();
      }
      // if a new date range was selected, invoke the user callback function
      if (!this.startDate()?.isSame(this._old.start) || !this.endDate()?.isSame(this._old.end)) {
        // this.callback(this.startDate(), this.endDate(), this.chosenLabel);
      }
      // if picker is attached to a text input, update it
      this.updateElement();
      this.isShown.set(false);
      this.applyBtnDisabled.set(true);
    }
    clearIncompleteDateSelection() {
      this.nowHoveredDate = null;
      this.pickingDate = false;
    }
    /**
     * handle click on all element in the component, useful for outside of click
     * @param e event
     */
    handleInternalClick(e) {
      e.stopPropagation();
    }
    /**
     * update the locale options
     * @param locale
     */
    updateLocale(locale) {
      for (const key in locale) {
        if (locale.hasOwnProperty(key)) {
          this._locale()[key] = locale[key];
        }
      }
    }
    /**
     *  clear the daterange picker
     */
    clickClear($event) {
      const start = this.timePicker24HourInterval()[0];
      const end = this.timePicker24HourInterval()[1];
      this.startDate.set(this.timePicker24Hour() && start !== 0 ? dayjs().startOf('day').add(start, 'hours') : dayjs().startOf('day'));
      this.endDate.set(this.timePicker24Hour() && end !== 23 ? dayjs().startOf('day').add(end, 'hours') : dayjs().endOf('day'));
      this.chosenDate.emit({
        chosenLabel: '',
        startDate: null,
        endDate: null
      });
      this.datesUpdated.emit({
        startDate: null,
        endDate: null
      });
      this.clearClicked.emit();
      this.hide();
    }
    /**
     * Find out if the selected range should be disabled if it doesn't
     * fit into minDate and maxDate limitations.
     */
    disableRange(range) {
      if (range === this._locale().customRangeLabel) {
        return false;
      }
      const rangeMarkers = this.ranges()[range];
      const areBothBefore = rangeMarkers.every(date => {
        if (!this.minDate()) {
          return false;
        }
        return date.isBefore(this.minDate());
      });
      const areBothAfter = rangeMarkers.every(date => {
        if (!this.maxDate()) {
          return false;
        }
        return date.isAfter(this.maxDate());
      });
      return areBothBefore || areBothAfter;
    }
    /**
     *
     * @param date the date to add time
     * @param side left or right
     */
    _getDateWithTime(date, side) {
      let hour = parseInt(this.timepickerVariables[side].selectedHour, 10);
      if (!this.timePicker24Hour()) {
        const ampm = this.timepickerVariables[side].ampmModel;
        if (ampm === 'PM' && hour < 12) hour += 12;
        if (ampm === 'AM' && hour === 12) hour = 0;
      }
      const minute = parseInt(this.timepickerVariables[side].selectedMinute, 10);
      const second = this.timePickerSeconds() ? parseInt(this.timepickerVariables[side].selectedSecond, 10) : 0;
      return date.clone().hour(hour).minute(minute).second(second);
    }
    /**
     *  build the locale config
     */
    _buildLocale() {
      if (!this._locale().format) {
        if (this.timePicker()) {
          this._locale().format = dayjs.localeData().longDateFormat('lll');
        } else {
          this._locale().format = dayjs.localeData().longDateFormat('L');
        }
      }
    }
    _buildCells(calendar, side) {
      for (let row = 0; row < 6; row++) {
        this.calendarVariables[side].classes[row] = {};
        const rowClasses = [];
        const emptyWeekRowClass = this.emptyWeekRowClass();
        if (emptyWeekRowClass && Array.from(Array(7).keys()).some(i => calendar[row][i].month() !== this.calendarVariables[side].month)) {
          rowClasses.push(emptyWeekRowClass);
        }
        for (let col = 0; col < 7; col++) {
          const classes = [];
          // empty week row class
          const emptyWeekColumnClass = this.emptyWeekColumnClass();
          if (emptyWeekColumnClass) {
            if (calendar[row][col].month() !== this.calendarVariables[side].month) {
              classes.push(emptyWeekColumnClass);
            }
          }
          // highlight today's date
          if (calendar[row][col].isSame(new Date(), 'day')) classes.push('today');
          // highlight weekends
          if (calendar[row][col].isoWeekday() > 5) classes.push('weekend');
          // grey out the dates in other months displayed at beginning and end of this calendar
          if (calendar[row][col].month() !== calendar[1][1].month()) {
            classes.push('off');
            // mark the last day of the previous month in this calendar
            const lastDayOfPreviousMonthClass = this.lastDayOfPreviousMonthClass();
            if (lastDayOfPreviousMonthClass && (calendar[row][col].month() < calendar[1][1].month() || calendar[1][1].month() === 0) && calendar[row][col].date() === this.calendarVariables[side].daysInLastMonth) {
              classes.push(lastDayOfPreviousMonthClass);
            }
            // mark the first day of the next month in this calendar
            const firstDayOfNextMonthClass = this.firstDayOfNextMonthClass();
            if (firstDayOfNextMonthClass && (calendar[row][col].month() > calendar[1][1].month() || calendar[row][col].month() === 0) && calendar[row][col].date() === 1) {
              classes.push(firstDayOfNextMonthClass);
            }
          }
          // mark the first day of the current month with a custom class
          const firstMonthDayClass = this.firstMonthDayClass();
          if (firstMonthDayClass && calendar[row][col].month() === calendar[1][1].month() && calendar[row][col].date() === calendar.firstDay.date()) {
            classes.push(firstMonthDayClass);
          }
          // mark the last day of the current month with a custom class
          const lastMonthDayClass = this.lastMonthDayClass();
          if (lastMonthDayClass && calendar[row][col].month() === calendar[1][1].month() && calendar[row][col].date() === calendar.lastDay.date()) {
            classes.push(lastMonthDayClass);
          }
          // don't allow selection of dates before the minimum date
          if (this.minDate() && calendar[row][col].isBefore(this.minDate(), 'day')) {
            classes.push('off', 'disabled');
          }
          // don't allow selection of dates after the maximum date
          if (this.calendarVariables[side].maxDate && calendar[row][col].isAfter(this.calendarVariables[side].maxDate, 'day')) {
            classes.push('off', 'disabled');
          }
          // don't allow selection of date if a custom function decides it's invalid
          if (this.isInvalidDate()(calendar[row][col])) {
            classes.push('off', 'disabled', 'invalid');
          }
          // highlight the currently selected start date
          if (this.startDate() && calendar[row][col].format('YYYY-MM-DD') === this.startDate()?.format('YYYY-MM-DD')) {
            classes.push('active', 'start-date');
          }
          // highlight the currently selected end date
          if (this.endDate() != null && calendar[row][col].format('YYYY-MM-DD') === this.endDate()?.format('YYYY-MM-DD')) {
            classes.push('active', 'end-date');
          }
          // highlight dates in-between the selected dates
          if ((this.nowHoveredDate != null && this.pickingDate || this.endDate() != null) && calendar[row][col] > this.startDate() && (calendar[row][col] < this.endDate() || calendar[row][col] < this.nowHoveredDate && this.pickingDate) && !classes.find(el => el === 'off')) {
            classes.push('in-range');
          }
          // apply custom classes for this date
          const isCustom = this.isCustomDate()(calendar[row][col]);
          if (isCustom !== false) {
            if (typeof isCustom === 'string') {
              classes.push(isCustom);
            } else {
              Array.prototype.push.apply(classes, isCustom);
            }
          }
          // apply custom tooltip for this date
          const isTooltip = this.isTooltipDate()(calendar[row][col]);
          if (isTooltip) {
            if (typeof isTooltip === 'string') {
              this.tooltiptext[calendar[row][col]] = isTooltip; // setting tooltiptext for custom date
            } else {
              this.tooltiptext[calendar[row][col]] = 'Put the tooltip as the returned value of isTooltipDate';
            }
          } else {
            this.tooltiptext[calendar[row][col]] = '';
          }
          // store classes var
          let cname = '',
            disabled = false;
          for (let i = 0; i < classes.length; i++) {
            cname += classes[i] + ' ';
            if (classes[i] === 'disabled') {
              disabled = true;
            }
          }
          if (!disabled) {
            cname += 'available';
          }
          this.calendarVariables[side].classes[row][col] = cname.replace(/^\s+|\s+$/g, '');
        }
        this.calendarVariables[side].classes[row].classList = rowClasses.join(' ');
      }
    }
    static ɵfac = function NgxDaterangepickerBootstrapComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxDaterangepickerBootstrapComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NgxDaterangepickerBootstrapComponent,
      selectors: [["ngx-daterangepicker-bootstrap"]],
      viewQuery: function NgxDaterangepickerBootstrapComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.pickerContainer, _c2, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostBindings: function NgxDaterangepickerBootstrapComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NgxDaterangepickerBootstrapComponent_click_HostBindingHandler($event) {
            return ctx.handleInternalClick($event);
          });
        }
      },
      inputs: {
        startDate: [1, "startDate"],
        endDate: [1, "endDate"],
        dateLimit: [1, "dateLimit"],
        autoApply: [1, "autoApply"],
        singleDatePicker: [1, "singleDatePicker"],
        showDropdowns: [1, "showDropdowns"],
        showWeekNumbers: [1, "showWeekNumbers"],
        showISOWeekNumbers: [1, "showISOWeekNumbers"],
        linkedCalendars: [1, "linkedCalendars"],
        autoUpdateInput: [1, "autoUpdateInput"],
        alwaysShowCalendars: [1, "alwaysShowCalendars"],
        maxSpan: [1, "maxSpan"],
        lockStartDate: [1, "lockStartDate"],
        timePicker: [1, "timePicker"],
        timePicker24Hour: [1, "timePicker24Hour"],
        timePickerIncrement: [1, "timePickerIncrement"],
        timePicker24HourInterval: [1, "timePicker24HourInterval"],
        timePickerSeconds: [1, "timePickerSeconds"],
        showClearButton: [1, "showClearButton"],
        firstMonthDayClass: [1, "firstMonthDayClass"],
        lastMonthDayClass: [1, "lastMonthDayClass"],
        emptyWeekRowClass: [1, "emptyWeekRowClass"],
        emptyWeekColumnClass: [1, "emptyWeekColumnClass"],
        firstDayOfNextMonthClass: [1, "firstDayOfNextMonthClass"],
        lastDayOfPreviousMonthClass: [1, "lastDayOfPreviousMonthClass"],
        showCustomRangeLabel: [1, "showCustomRangeLabel"],
        showCancel: [1, "showCancel"],
        keepCalendarOpeningWithRange: [1, "keepCalendarOpeningWithRange"],
        showRangeLabelOnInput: [1, "showRangeLabelOnInput"],
        customRangeDirection: [1, "customRangeDirection"],
        drops: [1, "drops"],
        opens: [1, "opens"],
        closeOnAutoApply: [1, "closeOnAutoApply"],
        minDate: [1, "minDate"],
        maxDate: [1, "maxDate"],
        locale: [1, "locale"],
        ranges: [1, "ranges"],
        isInvalidDate: [1, "isInvalidDate"],
        isCustomDate: [1, "isCustomDate"],
        isTooltipDate: [1, "isTooltipDate"]
      },
      outputs: {
        startDate: "startDateChange",
        endDate: "endDateChange",
        locale: "localeChange",
        chosenDate: "chosenDate",
        rangeClicked: "rangeClicked",
        datesUpdated: "datesUpdated",
        startDateChanged: "startDateChanged",
        endDateChanged: "endDateChanged",
        cancelClicked: "cancelClicked",
        clearClicked: "clearClicked"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 6,
      vars: 39,
      consts: [["pickerContainer", ""], [1, "card", "daterangepicker", 3, "ngClass"], [1, "card-body", "p-2"], [3, "rangeEvent", "rangesArray", "chosenRange", "locale", "ranges", "minDate", "maxDate"], [3, "prevEvent", "nextEvent", "monthChangedEvent", "yearChangedEvent", "dateEvent", "hoverDateEvent", "timeChangedEvent", "showCalInRanges", "singleDatePicker", "calendarVariables", "showWeekNumbers", "showISOWeekNumbers", "linkedCalendars", "showDropdowns", "locale", "timePicker", "startDate", "timepickerVariables", "timePickerSeconds", "timePicker24Hour"], [3, "applyEvent", "cancelEvent", "clearEvent", "autoApply", "rangesArray", "showCalInRanges", "singleDatePicker", "chosenLabel", "applyBtnDisabled", "locale", "showCancel", "showClearButton"]],
      template: function NgxDaterangepickerBootstrapComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1, 0)(2, "div", 2)(3, "ranges", 3);
          i0.ɵɵlistener("rangeEvent", function NgxDaterangepickerBootstrapComponent_Template_ranges_rangeEvent_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clickRange($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "calendar", 4);
          i0.ɵɵlistener("prevEvent", function NgxDaterangepickerBootstrapComponent_Template_calendar_prevEvent_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clickPrev($event));
          })("nextEvent", function NgxDaterangepickerBootstrapComponent_Template_calendar_nextEvent_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clickNext($event));
          })("monthChangedEvent", function NgxDaterangepickerBootstrapComponent_Template_calendar_monthChangedEvent_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.monthChanged($event));
          })("yearChangedEvent", function NgxDaterangepickerBootstrapComponent_Template_calendar_yearChangedEvent_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.yearChanged($event));
          })("dateEvent", function NgxDaterangepickerBootstrapComponent_Template_calendar_dateEvent_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clickDate($event));
          })("hoverDateEvent", function NgxDaterangepickerBootstrapComponent_Template_calendar_hoverDateEvent_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.hoverDate($event));
          })("timeChangedEvent", function NgxDaterangepickerBootstrapComponent_Template_calendar_timeChangedEvent_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.timeChanged($event));
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(5, "actions", 5);
          i0.ɵɵlistener("applyEvent", function NgxDaterangepickerBootstrapComponent_Template_actions_applyEvent_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clickApply($event));
          })("cancelEvent", function NgxDaterangepickerBootstrapComponent_Template_actions_cancelEvent_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clickCancel($event));
          })("clearEvent", function NgxDaterangepickerBootstrapComponent_Template_actions_clearEvent_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clickClear($event));
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.drops() + " " + ctx.opens());
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(31, _c3, ctx.rangesArray.length, ctx.isShown() || ctx.inline, !ctx.isShown() && !ctx.inline, !ctx.singleDatePicker() && ctx.showCalInRanges, ctx.inline, ctx._locale().direction === "ltr", ctx._locale().direction === "rtl"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("rangesArray", ctx.rangesArray)("chosenRange", ctx.chosenRange)("locale", ctx._locale())("ranges", ctx.ranges())("minDate", ctx.minDate())("maxDate", ctx.maxDate());
          i0.ɵɵadvance();
          i0.ɵɵproperty("showCalInRanges", ctx.showCalInRanges)("singleDatePicker", ctx.singleDatePicker())("calendarVariables", ctx.calendarVariables)("showWeekNumbers", ctx.showWeekNumbers())("showISOWeekNumbers", ctx.showISOWeekNumbers())("linkedCalendars", ctx.linkedCalendars())("showDropdowns", ctx.showDropdowns())("locale", ctx._locale())("timePicker", ctx.timePicker())("startDate", ctx.startDate())("timepickerVariables", ctx.timepickerVariables)("timePickerSeconds", ctx.timePickerSeconds())("timePicker24Hour", ctx.timePicker24Hour());
          i0.ɵɵadvance();
          i0.ɵɵproperty("autoApply", ctx.autoApply())("rangesArray", ctx.rangesArray)("showCalInRanges", ctx.showCalInRanges)("singleDatePicker", ctx.singleDatePicker())("chosenLabel", ctx.chosenLabel)("applyBtnDisabled", ctx.applyBtnDisabled())("locale", ctx._locale())("showCancel", ctx.showCancel())("showClearButton", ctx.showClearButton());
        }
      },
      dependencies: [NgClass, FormsModule, RangesComponent, CalendarComponent, ActionsComponent],
      styles: [".unwrap.on{display:contents}.unwrap.off{overflow:hidden;height:0;width:0}.daterangepicker{position:absolute;width:auto;z-index:3001;margin-top:6px;margin-bottom:6px;box-shadow:0 2px 4px #00000029,0 2px 8px #0000001f}.daterangepicker:after{top:-6px;border-right:6px solid transparent;border-left:6px solid transparent;border-bottom:6px solid #fff}.daterangepicker.left:before{right:9px}.daterangepicker.left:after{right:10px}.daterangepicker.center:before{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.daterangepicker.center:after{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.daterangepicker.right:before{left:9px}.daterangepicker.right:after{left:10px}.daterangepicker.up{margin-top:-7px}.daterangepicker.up:before{top:initial;bottom:-7px;border-bottom:initial;border-top:7px solid #ccc}.daterangepicker.up:after{top:initial;bottom:-6px;border-bottom:initial;border-top:6px solid #fff}.daterangepicker.single .ranges,.daterangepicker.single .calendar{float:none}.daterangepicker.double{width:auto}.daterangepicker.inline{position:relative;display:inline-grid}.daterangepicker.inline:before{content:none}.daterangepicker.inline:after{content:none}.daterangepicker.shown{transform:scale(1);transform-origin:0 0;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.daterangepicker.shown .calendar{display:block}.daterangepicker.hidden{transform:scale(0);transform-origin:0 0;cursor:default;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.daterangepicker.hidden .calendar{display:none}.daterangepicker .label-input{border:1px solid #ccc;border-radius:calc(.5rem - 1px);color:#555;height:30px;line-height:30px;display:block;vertical-align:middle;margin:0 auto 5px;padding:0 0 0 28px;width:100%}.daterangepicker .label-input.active{border:1px solid #08c;border-radius:calc(.5rem - 1px)}.daterangepicker .daterangepicker_input{position:relative;padding:0 30px 0 0}.daterangepicker .daterangepicker_input i,.daterangepicker .daterangepicker_input svg{position:absolute;left:8px;top:8px}.daterangepicker.rtl .label-input{padding-right:28px;padding-left:6px}.daterangepicker.rtl .daterangepicker_input i,.daterangepicker.rtl .daterangepicker_input svg{left:auto;right:8px}.daterangepicker:before,.daterangepicker:after{position:absolute;display:inline-block;border-bottom-color:#0003;content:\"\"}.daterangepicker:before{top:-7px;border-right:7px solid transparent;border-left:7px solid transparent;border-bottom:7px solid #ccc}.daterangepicker:after{top:-6px;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.daterangepicker.opensright:before{left:9px}.daterangepicker.opensright:after{left:10px}@media (min-width: 564px){.daterangepicker{width:auto}.daterangepicker.single .calendar.left{clear:none}.daterangepicker.ltr{direction:ltr;text-align:left}.daterangepicker.ltr .calendar.left{clear:left}.daterangepicker.ltr .calendar.left .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.daterangepicker.ltr .calendar.right{margin-left:0}.daterangepicker.ltr .calendar.right .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.daterangepicker.ltr .left .daterangepicker_input,.daterangepicker.ltr .right .daterangepicker_input{padding-right:35px}.daterangepicker.ltr .calendar.left .calendar-table{padding-right:12px}.daterangepicker.ltr .ranges,.daterangepicker.ltr .calendar{float:left}.daterangepicker.rtl{direction:rtl;text-align:right}.daterangepicker.rtl .calendar.left{clear:right;margin-left:0}.daterangepicker.rtl .calendar.left .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.daterangepicker.rtl .calendar.right{margin-right:0}.daterangepicker.rtl .calendar.right .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.daterangepicker.rtl .left .daterangepicker_input,.daterangepicker.rtl .calendar.left .calendar-table{padding-left:12px}.daterangepicker.rtl .ranges,.daterangepicker.rtl .calendar{text-align:right;float:right}}@media (min-width: 730px){.daterangepicker .ranges{width:auto}.daterangepicker.ltr .ranges{float:left}.daterangepicker.rtl .ranges{float:right}.daterangepicker .calendar.left{clear:none!important}}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NgxDaterangepickerBootstrapComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxDaterangepickerBootstrapDirective = /*#__PURE__*/(() => {
  class NgxDaterangepickerBootstrapDirective {
    viewContainerRef = inject(ViewContainerRef);
    injector = inject(Injector);
    applicationRef = inject(ApplicationRef);
    elementRef = inject(ElementRef);
    _renderer = inject(Renderer2);
    _localeService = inject(NgxDaterangepickerLocaleService);
    $event;
    daterangepicker;
    daterangepickerRef;
    daterangepickerElement;
    firstMonthDayClass;
    _onChange = Function.prototype;
    _onTouched = Function.prototype;
    _disabled;
    _value;
    _resizeObserver;
    minDate = input();
    maxDate = input();
    autoApply = input(false);
    alwaysShowCalendars = input(false);
    showCustomRangeLabel = input();
    linkedCalendars = input(false);
    dateLimit = input(null);
    singleDatePicker = input(false);
    showWeekNumbers = input(false);
    showISOWeekNumbers = input(false);
    showDropdowns = input(false);
    isInvalidDate = input();
    isCustomDate = input();
    isTooltipDate = input();
    showClearButton = input(false);
    customRangeDirection = input(false);
    ranges = input(null);
    opens = model('right');
    drops = model('down');
    lastMonthDayClass = input(null);
    emptyWeekRowClass = input(null);
    emptyWeekColumnClass = input(null);
    firstDayOfNextMonthClass = input(null);
    lastDayOfPreviousMonthClass = input(null);
    keepCalendarOpeningWithRange = input(false);
    showRangeLabelOnInput = input(false);
    showCancel = input(false);
    lockStartDate = input(false);
    closeOnAutoApply = input(true);
    timePicker = input(false);
    timePicker24Hour = input(false);
    timePickerIncrement = input(1);
    timePicker24HourInterval = input([0, 23]);
    timePickerSeconds = input(false);
    formlyCustomField = input(false); // if you use ngx-formly and create custom field this library
    startKey = model('startDate');
    endKey = model('endDate');
    locale = model({});
    _startKey = computed(() => this.startKey() !== null ? this.startKey() : 'startDate');
    _endKey = computed(() => this.endKey() !== null ? this.endKey() : 'endDate');
    _locale = computed(() => this.locale() !== null ? {
      ...this._localeService.config,
      ...this.locale()
    } : {});
    change = output();
    rangeClicked = output();
    datesUpdated = output();
    startDateChanged = output();
    endDateChanged = output();
    clearClicked = output();
    get disabled() {
      return this._disabled;
    }
    get value() {
      return this._value || null;
    }
    set value(val) {
      this._value = val;
      this._onChange(val);
    }
    rangeClickedSubs;
    datesUpdatedSubs;
    startDateChangedSubs;
    endDateChangedSubs;
    clearClickedSubs;
    chosenDateSubs;
    constructor() {
      this.viewContainerRef.clear();
      this.daterangepickerRef = this.viewContainerRef.createComponent(NgxDaterangepickerBootstrapComponent, {
        injector: this.injector
      });
      this.daterangepickerElement = this.daterangepickerRef.hostView.rootNodes[0];
      CSS.supports('display', 'contents') // unwrap or hide daterangepickerElement from DOM body, to fix clickOutside
      ? this.daterangepickerElement.classList.add('unwrap', 'on') : this.daterangepickerElement.classList.add('unwrap', 'off');
      document.body.appendChild(this.daterangepickerElement); // add daterangepickerElement to DOM body, to fix position top left issues
      this.daterangepicker = this.daterangepickerRef.instance;
      this.daterangepicker.inline = false; // set inline to false for all directive usage
      effect(() => {
        this.daterangepicker.updateLocale(this._locale());
      });
    }
    ngOnInit() {
      this.daterangepickerRef?.setInput('autoApply', this.autoApply());
      this.daterangepickerRef?.setInput('alwaysShowCalendars', this.alwaysShowCalendars());
      this.daterangepickerRef?.setInput('showCustomRangeLabel', this.showCustomRangeLabel());
      this.daterangepickerRef?.setInput('linkedCalendars', this.linkedCalendars());
      this.daterangepickerRef?.setInput('dateLimit', this.dateLimit());
      this.daterangepickerRef?.setInput('singleDatePicker', this.singleDatePicker());
      this.daterangepickerRef?.setInput('showWeekNumbers', this.showWeekNumbers());
      this.daterangepickerRef?.setInput('showISOWeekNumbers', this.showISOWeekNumbers());
      this.daterangepickerRef?.setInput('showDropdowns', this.showDropdowns());
      this.daterangepickerRef?.setInput('showClearButton', this.showClearButton());
      this.daterangepickerRef?.setInput('customRangeDirection', this.customRangeDirection());
      this.daterangepickerRef?.setInput('locale', this.locale());
      this.daterangepickerRef?.setInput('ranges', this.ranges());
      this.daterangepickerRef?.setInput('opens', this.opens());
      this.daterangepickerRef?.setInput('drops', this.drops());
      this.daterangepickerRef?.setInput('lastMonthDayClass', this.lastMonthDayClass());
      this.daterangepickerRef?.setInput('emptyWeekRowClass', this.emptyWeekRowClass());
      this.daterangepickerRef?.setInput('emptyWeekColumnClass', this.emptyWeekColumnClass());
      this.daterangepickerRef?.setInput('firstDayOfNextMonthClass', this.firstDayOfNextMonthClass());
      this.daterangepickerRef?.setInput('lastDayOfPreviousMonthClass', this.lastDayOfPreviousMonthClass());
      this.daterangepickerRef?.setInput('keepCalendarOpeningWithRange', this.keepCalendarOpeningWithRange());
      this.daterangepickerRef?.setInput('showRangeLabelOnInput', this.showRangeLabelOnInput());
      this.daterangepickerRef?.setInput('showCancel', this.showCancel());
      this.daterangepickerRef?.setInput('lockStartDate', this.lockStartDate());
      this.daterangepickerRef?.setInput('closeOnAutoApply', this.closeOnAutoApply());
      this.daterangepickerRef?.setInput('timePicker', this.timePicker());
      this.daterangepickerRef?.setInput('timePicker24Hour', this.timePicker24Hour());
      this.daterangepickerRef?.setInput('timePicker24HourInterval', this.timePicker24HourInterval());
      this.daterangepickerRef?.setInput('timePickerIncrement', this.timePickerIncrement());
      this.daterangepickerRef?.setInput('timePickerSeconds', this.timePickerSeconds());
      this.daterangepickerRef?.setInput('firstMonthDayClass', this.firstMonthDayClass);
      if (this.minDate() !== undefined) this.daterangepickerRef?.setInput('minDate', this.minDate());
      if (this.maxDate() !== undefined) this.daterangepickerRef?.setInput('maxDate', this.maxDate());
      if (this.isInvalidDate() !== undefined) this.daterangepickerRef?.setInput('isInvalidDate', this.isInvalidDate());
      if (this.isCustomDate() !== undefined) this.daterangepickerRef?.setInput('isCustomDate', this.isCustomDate());
      if (this.isTooltipDate() !== undefined) this.daterangepickerRef?.setInput('isTooltipDate', this.isTooltipDate());
      this.rangeClickedSubs = this.daterangepicker.rangeClicked.subscribe(range => this.rangeClicked.emit(range));
      this.datesUpdatedSubs = this.daterangepicker.datesUpdated.subscribe(range => this.datesUpdated.emit(range));
      this.startDateChangedSubs = this.daterangepicker.startDateChanged.subscribe(itemChanged => this.startDateChanged.emit(itemChanged));
      this.endDateChangedSubs = this.daterangepicker.endDateChanged.subscribe(itemChanged => this.endDateChanged.emit(itemChanged));
      this.clearClickedSubs = this.daterangepicker.clearClicked.subscribe(() => this.clearClicked.emit());
      this.chosenDateSubs = this.daterangepicker.chosenDate.subscribe(change => {
        if (change) {
          const value = {};
          value[this._startKey()] = change.startDate;
          value[this._endKey()] = change.endDate;
          this.value = value;
          this.change.emit(value);
          if (typeof change.chosenLabel === 'string') {
            this.elementRef.nativeElement.value = change.chosenLabel;
          }
        }
      });
      this.pickerResizeObserver();
    }
    ngOnDestroy() {
      this._resizeObserver?.unobserve(this.daterangepicker.pickerContainer().nativeElement);
      if (this.daterangepickerElement !== null) document.body.removeChild(this.daterangepickerElement);
      this.applicationRef.detachView(this.daterangepickerRef.hostView);
      this.rangeClickedSubs?.unsubscribe();
      this.datesUpdatedSubs?.unsubscribe();
      this.startDateChangedSubs?.unsubscribe();
      this.endDateChangedSubs?.unsubscribe();
      this.clearClickedSubs?.unsubscribe();
      this.chosenDateSubs?.unsubscribe();
      this.daterangepickerRef?.destroy();
    }
    ngAfterViewInit() {
      if (this.formlyCustomField()) this.writeValue(this._locale()); // If you use ngx-formly custom field, remove [(ngModel)]
      // from the input and set [formlyCustomField]='true' instead, to avoid Expression has changed after it was checked.
    }
    ngAfterViewChecked() {
      if (this.daterangepicker.isShown()) this.setPosition();
    }
    onWindowResize(event) {
      if (this.daterangepicker.isShown()) this.setPosition();
    }
    open(event) {
      if (this.disabled) return;
      this.daterangepicker.show(event);
      if (this.daterangepicker.isShown()) this.setPosition();
    }
    hide(event) {
      this.daterangepicker.hide(event);
    }
    onBlur() {
      this._onTouched();
    }
    toggle(event) {
      this.daterangepicker.isShown() ? this.hide(event) : this.open(event);
    }
    clear() {
      this.daterangepicker.clickClear();
    }
    writeValue(value) {
      this.setValue(value);
    }
    registerOnChange(fn) {
      this._onChange = fn;
    }
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    setDisabledState(state) {
      this._disabled = state;
    }
    setValue(val) {
      if (val) {
        this.value = val;
        if (val[this._startKey()]) {
          this.daterangepicker.setStartDate(val[this._startKey()]);
        }
        if (val[this._endKey()]) {
          this.daterangepicker.setEndDate(val[this._endKey()]);
        }
        this.daterangepicker.calculateChosenLabel();
        if (this.daterangepicker.chosenLabel) {
          this.elementRef.nativeElement.value = this.daterangepicker.chosenLabel;
        }
      } else {
        this.daterangepicker.clickClear();
      }
    }
    pickerResizeObserver() {
      this._resizeObserver = new ResizeObserver(() => {
        // if (this.daterangepicker.isShown()) this.setPosition();
      });
      this._resizeObserver.observe(this.daterangepicker.pickerContainer().nativeElement);
    }
    /**
     * Set position of the calendar, this works as expected only if you add daterangepickerElement to DOM body
     */
    setPosition() {
      const pickerContainer = this.daterangepicker.pickerContainer().nativeElement;
      const inputOffset = this.getOffset(this.elementRef.nativeElement);
      let containerTop;
      let containerBottom;
      if (this.drops() && this.drops() === 'down') {
        containerTop = inputOffset.top + inputOffset.height + 'px';
        containerBottom = 'auto';
      }
      if (this.drops() && this.drops() === 'up') {
        containerTop = 'auto';
        containerBottom = window.innerHeight - inputOffset.top + 'px';
      }
      let style;
      if (this.opens() === 'right') {
        style = {
          top: containerTop,
          right: 'auto',
          bottom: containerBottom,
          left: inputOffset.left + 'px'
        };
      }
      if (this.opens() === 'center') {
        style = {
          top: containerTop,
          right: 'auto',
          bottom: containerBottom,
          left: inputOffset.left + (inputOffset.width - pickerContainer.offsetWidth) / 2 + 'px'
        };
      }
      if (this.opens() === 'left') {
        style = {
          top: containerTop,
          right: window.innerWidth - (inputOffset.left + inputOffset.width) + 'px',
          bottom: containerBottom,
          left: 'auto'
        };
      }
      if (style) {
        /* inset: top right bottom left */
        this._renderer.setStyle(pickerContainer, 'top', style.top);
        this._renderer.setStyle(pickerContainer, 'right', style.right);
        this._renderer.setStyle(pickerContainer, 'bottom', style.bottom);
        this._renderer.setStyle(pickerContainer, 'left', style.left);
      }
    }
    getOffset(element) {
      const rect = element.getBoundingClientRect();
      return {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
        height: rect.height,
        width: rect.width
      };
    }
    inputChanged(event) {
      if (event.target.tagName.toLowerCase() !== 'input') return;
      if (!event.target.value.length) return;
      const dateString = event.target.value.split(this.daterangepicker.locale.separator);
      let start = null,
        end = null;
      if (dateString.length === 2) {
        start = dayjs(dateString[0], this.daterangepicker.locale.format);
        end = dayjs(dateString[1], this.daterangepicker.locale.format);
      }
      if (this.singleDatePicker() || start === null || end === null) {
        start = dayjs(event.target.value, this.daterangepicker.locale.format);
        end = start;
      }
      if (!start.isValid() || !end.isValid()) return;
      this.daterangepicker.setStartDate(start);
      this.daterangepicker.setEndDate(end);
      this.daterangepicker.updateView();
    }
    /**
     * For click outside the calendar's container
     * @param event event object
     */
    outsideClick(event) {
      if (!event.target || event.target.classList.contains('ngx-daterangepicker-action')) return;
      if (!this.elementRef.nativeElement.contains(event.target)) this.hide();
    }
    static ɵfac = function NgxDaterangepickerBootstrapDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxDaterangepickerBootstrapDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgxDaterangepickerBootstrapDirective,
      selectors: [["input", "ngxDaterangepickerBootstrap", ""]],
      hostVars: 1,
      hostBindings: function NgxDaterangepickerBootstrapDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NgxDaterangepickerBootstrapDirective_click_HostBindingHandler() {
            return ctx.open();
          })("blur", function NgxDaterangepickerBootstrapDirective_blur_HostBindingHandler() {
            return ctx.onBlur();
          })("keyup", function NgxDaterangepickerBootstrapDirective_keyup_HostBindingHandler($event) {
            return ctx.inputChanged($event);
          })("keyup.esc", function NgxDaterangepickerBootstrapDirective_keyup_esc_HostBindingHandler() {
            return ctx.hide();
          })("resize", function NgxDaterangepickerBootstrapDirective_resize_HostBindingHandler($event) {
            return ctx.onWindowResize($event);
          }, false, i0.ɵɵresolveWindow)("click", function NgxDaterangepickerBootstrapDirective_click_HostBindingHandler($event) {
            return ctx.outsideClick($event);
          }, false, i0.ɵɵresolveDocument);
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("disabled", ctx.disabled);
        }
      },
      inputs: {
        minDate: [1, "minDate"],
        maxDate: [1, "maxDate"],
        autoApply: [1, "autoApply"],
        alwaysShowCalendars: [1, "alwaysShowCalendars"],
        showCustomRangeLabel: [1, "showCustomRangeLabel"],
        linkedCalendars: [1, "linkedCalendars"],
        dateLimit: [1, "dateLimit"],
        singleDatePicker: [1, "singleDatePicker"],
        showWeekNumbers: [1, "showWeekNumbers"],
        showISOWeekNumbers: [1, "showISOWeekNumbers"],
        showDropdowns: [1, "showDropdowns"],
        isInvalidDate: [1, "isInvalidDate"],
        isCustomDate: [1, "isCustomDate"],
        isTooltipDate: [1, "isTooltipDate"],
        showClearButton: [1, "showClearButton"],
        customRangeDirection: [1, "customRangeDirection"],
        ranges: [1, "ranges"],
        opens: [1, "opens"],
        drops: [1, "drops"],
        lastMonthDayClass: [1, "lastMonthDayClass"],
        emptyWeekRowClass: [1, "emptyWeekRowClass"],
        emptyWeekColumnClass: [1, "emptyWeekColumnClass"],
        firstDayOfNextMonthClass: [1, "firstDayOfNextMonthClass"],
        lastDayOfPreviousMonthClass: [1, "lastDayOfPreviousMonthClass"],
        keepCalendarOpeningWithRange: [1, "keepCalendarOpeningWithRange"],
        showRangeLabelOnInput: [1, "showRangeLabelOnInput"],
        showCancel: [1, "showCancel"],
        lockStartDate: [1, "lockStartDate"],
        closeOnAutoApply: [1, "closeOnAutoApply"],
        timePicker: [1, "timePicker"],
        timePicker24Hour: [1, "timePicker24Hour"],
        timePickerIncrement: [1, "timePickerIncrement"],
        timePicker24HourInterval: [1, "timePicker24HourInterval"],
        timePickerSeconds: [1, "timePickerSeconds"],
        formlyCustomField: [1, "formlyCustomField"],
        startKey: [1, "startKey"],
        endKey: [1, "endKey"],
        locale: [1, "locale"]
      },
      outputs: {
        opens: "opensChange",
        drops: "dropsChange",
        startKey: "startKeyChange",
        endKey: "endKeyChange",
        locale: "localeChange",
        change: "change",
        rangeClicked: "rangeClicked",
        datesUpdated: "datesUpdated",
        startDateChanged: "startDateChanged",
        endDateChanged: "endDateChanged",
        clearClicked: "clearClicked"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NgxDaterangepickerBootstrapDirective),
        multi: true
      }])]
    });
  }
  return NgxDaterangepickerBootstrapDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxDaterangepickerBootstrapModule = /*#__PURE__*/(() => {
  class NgxDaterangepickerBootstrapModule {
    static forRoot(config = {}) {
      return {
        ngModule: NgxDaterangepickerBootstrapModule,
        providers: [{
          provide: LOCALE_CONFIG,
          useValue: config
        }, {
          provide: NgxDaterangepickerLocaleService,
          useClass: NgxDaterangepickerLocaleService,
          deps: [LOCALE_CONFIG]
        }]
      };
    }
    static ɵfac = function NgxDaterangepickerBootstrapModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxDaterangepickerBootstrapModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NgxDaterangepickerBootstrapModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxDaterangepickerBootstrapComponent]
    });
  }
  return NgxDaterangepickerBootstrapModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideDaterangepickerLocale(config = {}) {
  return makeEnvironmentProviders([{
    provide: LOCALE_CONFIG,
    useValue: config
  }, {
    provide: NgxDaterangepickerLocaleService,
    useClass: NgxDaterangepickerLocaleService,
    deps: [LOCALE_CONFIG]
  }]);
}

/*
 * Public API Surface of ngx-daterangepicker-bootstrap
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DefaultLocaleConfig, LOCALE_CONFIG, NgxDaterangepickerBootstrapComponent, NgxDaterangepickerBootstrapDirective, NgxDaterangepickerBootstrapModule, NgxDaterangepickerLocaleService, provideDaterangepickerLocale };
